import React, { useEffect, memo, useState, useRef } from "react";
import { Button, Col, Modal, Row, Form, OverlayTrigger, Tooltip, Spinner, Dropdown } from 'react-bootstrap';
import SectionLoader from '../../../components/SectionLoader';
import { Link, useNavigate } from 'react-router-dom'
import { Tabs, Tab } from "react-bootstrap";
import DeleteConfirmation from "./DeleteConfirmation";
import FullSiteTrainingConfirmation from "./FullSiteTrainingConfirmation";
import axios from "axios";
import { info, error, success, getApiMessage } from "../../../notify";
import { clearAuthStorage } from "../../../interceptor";

const Site = memo((props) => {
    let history = useNavigate();
    const userRole = sessionStorage.getItem("userRole");

    let siteLabel = "site"
    let siteLabelC = "Site"
    if (userRole === "ADMIN") {
        siteLabel = "client"
        siteLabelC = "Client"
    }

    const ERR_NETWORK_MESSAGE = 'Server is not available.'
    const token = sessionStorage.getItem("revizeTrainingToken");
    const [userSiteData, setUserSiteData] = useState([])
    const [filteredSiteData, setFilteredSiteData] = useState([])
    const userSiteApi = `${process.env.REACT_APP_SERVER_URL}/api/website/`;
    const addSiteApi = `${process.env.REACT_APP_SERVER_URL}/api/website`;
    const editSiteApi = `${process.env.REACT_APP_SERVER_URL}/api/website/`;
    const deleteSiteApi = `${process.env.REACT_APP_SERVER_URL}/api/website/`;
    const fullSiteTrainingApi = `${process.env.REACT_APP_SERVER_URL}/api/full_site_training/`;
    const getPageLimitApi = `${process.env.REACT_APP_SERVER_URL}/api/get_page_limit/`;
    const setPageLimitURL = `${process.env.REACT_APP_SERVER_URL}/api/set-page-limit/`;
    const userApi = `${process.env.REACT_APP_SERVER_URL}/api/users/me`;
    const uploadIconApi = `${process.env.REACT_APP_SERVER_URL}/api/website/assets/upload-icon`;

    const defaultBanenrURL = "https://images.unsplash.com/photo-1557683311-eac922347aa1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=829&q=80";

    const [showAddSite, setShowAddSite] = useState(false);
    const handleCloseAddSite = () => {
        setEnableFullSiteTraining(false);
        setEnableFileTrain(false);
        setEnableDelete(true);
        setSaveDeletedLogs(false);
        setSiteName("");
        setBotName("");
        setDomainUrl("");
        setRateLimit(0);
        setAutoTrainingInterval(0);
        setBannerUrlError("");
        setRateLimitError("");
        setBotNameError("");
        setSiteNameError("");
        setDomainUrlError("");
        setAutoTrainingIntervalError("");
        setEnableFullSiteTrainingError("");
        setShowAddSite(false);
    }
    const handleShowAddSite = () => setShowAddSite(true);

    const [showEditSite, setShowEditSite] = useState(false);
    const handleCloseEditSite = () => {
        setBannerUrlError("");
        setRateLimitError("");
        setBotNameError("");
        setSiteNameError("");
        setDomainUrlError("");
        setAutoTrainingIntervalError("");
        setEnableFileTrain(false);
        setEnableFullSiteTraining(false);
        setAutoTrainingInterval("");
        setQdrantDbUrl("");
        setEnableDelete(true);
        setSaveDeletedLogs(false);
        setShowEditSite(false);
    }

    const handleShowEditSite = (
        siteId, siteName, key, botName, bannerUrl, rateLimit,
        enableFileTrain, domainUrl, qdrant_db_url, enableFullSiteTraining,
        autoTrainingInterval, enableDelete, saveDeletedLogs
    ) => {
        setSiteId(siteId);
        setSiteName(siteName);
        setKey(key);
        setBotName(botName);
        setBannerUrl(bannerUrl);
        setRateLimit(rateLimit);
        setEnableFileTrain(enableFileTrain);
        setDomainUrl(domainUrl);
        setQdrantDbUrl(qdrant_db_url)
        setEnableFullSiteTraining(enableFullSiteTraining);
        setAutoTrainingInterval(autoTrainingInterval);
        setEnableDelete(enableDelete);
        setSaveDeletedLogs(saveDeletedLogs);
        setShowEditSite(true);
    };

    const [showSiteScript, setShowSiteScript] = useState(false);
    const handleCloseSiteScript = () => setShowSiteScript(false);

    const [selectedIcon, setSelectedIcon] = useState("");
    const [selectedMessageIcon, setSelectedMessageIcon] = useState("");

    const [botScriptKey, setBotScriptKey] = useState("");
    const [botScriptName, setBotScriptName] = useState("");

    const handleShowSiteScript = (botName, key) => {
        const chatbotHtml = `
            <iframe id="botIframe" align="right" scrolling="no" hidden="hidden" allow="microphone"
                src="${process.env.REACT_APP_CHATBOT_URL}/?websiteRef=${key}" 
                style="position:fixed; right:10px; bottom:45px; width:400px; height:620px; 
                box-shadow:0 20px 80px rgba(0,0,0,.6); border-radius:5px; overflow:hidden; border:none;">
            </iframe> 
                <button id="button1" onclick="hideToggle();" 
                style="position:fixed; right:10px; bottom:5px; width:130px; padding:10px; 
                background-color:rgb(71, 85, 105); color:white; font-weight:600; 
                border-radius:10px; overflow: hidden; text-overflow: ellipsis;">
                Show ${botName}
            </button>`;

        const chatbotJs = `
            <script>
            function hideToggle() {
                let iframe = document.getElementById("botIframe");
                let hidden = iframe.getAttribute("hidden");
                
                if (hidden) {
                iframe.removeAttribute("hidden");
                document.getElementById("button1").innerText = "Hide RevizeBot";
                } else {
                iframe.setAttribute("hidden", "hidden");
                document.getElementById("button1").innerText = "Show RevizeBot";
                }
            }

            async function loadButtonIcon() {
                try {
                const res = await fetch(
                    "${process.env.REACT_APP_SERVER_URL}/api/website/assets/get_icon_name/${key}?icon_type=CHATBOT_LOGO"
                );
                if (!res.ok) throw new Error("Failed to fetch icon name");
                const iconName = await res.json();

                if (iconName) {
                    const iconRes = await fetch(
                    "${process.env.REACT_APP_SERVER_URL}/api/website/assets/icon/" + iconName
                    );
                    if (!iconRes.ok) throw new Error("Failed to fetch icon image");
                    const selectedIcon = await iconRes.json();

                    if (selectedIcon) {
                    const button = document.getElementById("button1");
                    const img = document.createElement("img");
                    img.src = selectedIcon.image; 
                    img.alt = "${botScriptName}";
                    img.style.position = "fixed";
                    img.style.right = "10px";
                    img.style.bottom = "5px";
                    img.style.width = "50px";
                    img.style.height = "50px";
                    img.style.cursor = "pointer";
                    img.style.borderRadius = "50%";
                    img.id = "botIcon";
                    img.onclick = hideToggle;

                    button.parentNode.replaceChild(img, button);
                    }
                }
                } catch (err) {
                console.error("Error loading button icon:", err);
                }
            }

            window.addEventListener("DOMContentLoaded", loadButtonIcon);
            </script>`;

        const sourceFinderHtml = `
          <div style="position: relative; width: 50%;">
            <div id="languageContainer" style="position: absolute; top: 50%; right: 70px; transform: translateY(-50%); z-index: 100;">
                <button id="languageButton" style="padding: 0 0.5rem; font-size: 0.875rem; border-radius: 0.375rem; border: 1px solid #e5e7eb; height: 2rem; background: white; cursor: pointer;">en</button>
                <div id="languageDropdown" style="position: absolute; right: 0; top: calc(100% + 0.25rem); background: white; border: 1px solid #e5e7eb; border-radius: 0.375rem; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); max-height: 15rem; overflow-y: auto; display: none;"></div>
            </div>

            <iframe 
                id="searchBoxFrame" 
                src="https://chatbot.revize.com/source_finder/search_box?websiteRef=${key}
                scrolling="no"
                style="height: 0; width: 100%; border: none; position: relative;"
            ></iframe>
            
            <div 
                id="resultsContainer"
                style="position: absolute; top: 100%; left: 0; width: 100%; height: 0; overflow-y: hidden; z-index: 10; transition: height 0.3s ease;"
            >
                <iframe 
                    id="resultsFrame" 
                    src="about:blank" 
                    style="width: 100%; height: 0; border: none; display: block;"
                    title="Results"
                    frameborder="0"
                ></iframe>
            </div>
        </div>`;

        const sourceFinderJs = `
        <script>
        document.addEventListener('DOMContentLoaded', () => {
            const languageButton = document.getElementById('languageButton');
            const languageDropdown = document.getElementById('languageDropdown');
            const searchBoxFrame = document.getElementById('searchBoxFrame");
            const resultsFrame = document.getElementById('resultsFrame");
            const resultsContainer = document.getElementById('resultsContainer');
            let languages = [], languageCodes = {}, currentLanguage = "English";
            let searchBoxHeight = 0;

            const CHATBOT_URL = 'https://chatbot.revize.com';

            window.addEventListener('message', (event) => {
                const { type, data, height, constants } = event.data;
                
                switch (type) {
                    case 'searchBoxHeight':
                        searchBoxHeight = height;
                        requestAnimationFrame(() => {
                            searchBoxFrame.style.height = \`\${height}px\`;
                        });
                        break;

                    case 'resultsHeight':
                        requestAnimationFrame(() => {
                            const viewportHeight = window.innerHeight;
                            const maxHeight = viewportHeight * 0.7;
                            
                            resultsContainer.style.top = \`\${searchBoxHeight}px\`;
                            resultsFrame.style.height = \`\${height + 20}px\`;
                            
                            if (height > maxHeight) {
                                resultsContainer.style.height = \`\${maxHeight}px\`;
                                resultsContainer.style.overflowY = 'auto';
                            } else {
                                resultsContainer.style.height = \`\`\${height + 20}px\`\`;
                                resultsContainer.style.overflowY = 'hidden';
                            }
                        });
                        break;

                    case 'searchParameters':
                        const params = new URLSearchParams({
                            query: data.query,
                            websiteRef: data.websiteRef,
                            selected_language: data.selected_language
                        }).toString();
                        resultsFrame.src = \`\${CHATBOT_URL}/source_finder/results?\${params}\`;
                        break;

                    case 'initialConstants':
                        languages = constants.languages;
                        languageCodes = constants.languageCodes;

                        languageDropdown.innerHTML = languages.map(lang => \`
                            <div data-lang="\${lang}" style="padding: 0.5rem; cursor: pointer; font-size: 0.875rem; border: none; background: none;">
                                \${lang} (\${languageCodes[lang] || lang})
                            </div>
                        \`).join('');
                        languageButton.textContent = languageCodes[currentLanguage];
                        break;
                }
            });

            window.addEventListener('resize', () => {
                if (resultsFrame && resultsContainer) {
                    const viewportHeight = window.innerHeight;
                    const maxHeight = viewportHeight * 0.7;
                    const contentHeight = parseInt(resultsFrame.style.height);
                    
                    if (contentHeight > maxHeight) {
                        resultsContainer.style.height = \`\${maxHeight}px\`;
                        resultsContainer.style.overflowY = 'auto';
                    }
                }
            });

            languageButton.addEventListener('click', (e) => {
                e.stopPropagation();
                languageDropdown.style.display = (languageDropdown.style.display === 'block') ? 'none' : 'block';
            });

            document.addEventListener('click', (e) => {
                if (!languageDropdown.contains(e.target)) {
                    languageDropdown.style.display = 'none';
                }
            });

            languageDropdown.addEventListener('click', (e) => {
                if (e.target.hasAttribute('data-lang')) {
                    currentLanguage = e.target.dataset.lang;
                    languageButton.textContent = languageCodes[currentLanguage];
                    languageDropdown.style.display = 'none';
                    searchBoxFrame.contentWindow.postMessage({ type: 'languageChange', language: currentLanguage }, '*');
                }
            });
        });
        </script>`;

        setChatbotHtml(chatbotHtml);
        setChatbotJs(chatbotJs);
        setSourceFinderHtml(sourceFinderHtml);
        setSourceFinderJs(sourceFinderJs);
        setShowSiteScript(true);
    };

    // Save chatbot logo when changed
    const handleIconSelect = (iconName, iconType) => {
        // Update local preview state immediately
        if (iconType === "CHATBOT_MESSAGE_ICON") {
            setSelectedMessageIcon(iconName);
        } else {
            setSelectedIcon(iconName);
        }

        if (botScriptKey) {
            const iconToSave = iconName === "Default" ? "Default" : iconName;
            // CRITICAL: Use correct field names matching your API response
            const fieldName = iconType === "CHATBOT_MESSAGE_ICON"
                ? "chatbot_message_icon_name"
                : "chatbot_icon_name";

            fetch(`${process.env.REACT_APP_SERVER_URL}/api/website/assets/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    websiteref: botScriptKey,
                    icon_name: iconToSave,
                    icon_type: iconType
                }),
            })
                .then(res => {
                    if (!res.ok) throw new Error("Failed to save icon");
                    return res.json();
                })
                .then(() => {
                    // UPDATE BOTH state arrays with CORRECT field name
                    const updateSiteData = (prev) => prev.map(site =>
                        site.key === botScriptKey
                            ? { ...site, [fieldName]: iconToSave }
                            : site
                    );

                    setUserSiteData(updateSiteData);
                    setFilteredSiteData(updateSiteData); // Critical for table rendering
                })
                .catch(err => {
                    console.error("Error saving asset:", err);
                    error("Failed to save icon selection", true);
                    // Revert local state on failure
                    if (iconType === "CHATBOT_MESSAGE_ICON") {
                        setSelectedMessageIcon(prev => prev === iconName ? "" : prev);
                    } else {
                        setSelectedIcon(prev => prev === iconName ? "" : prev);
                    }
                });
        }
    };

    const [showDeleteSite, setShowDeleteSite] = useState(false);
    const handleCloseDeleteSite = () => setShowDeleteSite(false);
    const handleShowDeleteSite = (siteId, siteName, key) => {
        setSiteId(siteId);
        setSiteName(siteName);
        setKey(key);
        setDeleteMessage("Are you sure you want to delete the " + siteLabel + " " + siteName + "? Once " + siteLabel +
            " is deleted, it will also delete all trained " + siteLabel + " data.");
        setShowDeleteSite(true);
        setSiteName("")
    };
    const [deleteMessage, setDeleteMessage] = useState(null);

    const [showFSTConfirm, setShowFSTConfirm] = useState(false);
    const [proceedFST, setProceedFST] = useState(false);
    const handleCloseFSTConfirm = () => setShowFSTConfirm(false);
    const handleShowFSTConfirm = (siteId, siteName, key, enable_full_site_training) => {
        const boolValue = enable_full_site_training === true;
        if (boolValue) {
            setConfirmFTSMessage("Do you want to continue with Full Site Training for  " + siteLabel + " " + siteName + "?");
        } else {
            setConfirmFTSMessage("Full Site Training is not enabled for " + siteLabel + " " + siteName + ". Please Enable Full Site Training and try again.");
        }
        setSiteId(siteId);
        setSiteName(siteName);
        setKey(key);
        setProceedFST(boolValue);
        setShowFSTConfirm(true);
    };
    const [confirmFTSMessage, setConfirmFTSMessage] = useState(null);

    const [siteId, setSiteId] = useState("");
    const [siteName, setSiteName] = useState("");
    const [key, setKey] = useState("");
    const [enableFileTrain, setEnableFileTrain] = useState(false);
    const [enableFullSiteTraining, setEnableFullSiteTraining] = useState(false);
    const [rateLimit, setRateLimit] = useState(0);
    const [autoTrainingInterval, setAutoTrainingInterval] = useState(0);
    const [botName, setBotName] = useState("");
    const [bannerUrl, setBannerUrl] = useState(defaultBanenrURL);
    const [domainUrl, setDomainUrl] = useState("");
    const [siteCount, setSiteCount] = useState(0);
    const [currentSiteInfo, setCurrentSiteInfo] = useState({
        siteName: '',
        botName: '',
        domainUrl: '',
        qdrantDbUrl: '',
        bannerUrl: '',
        enableFullSiteTraining: false,
        enableFileTrain: false,
        autoTrainingInterval: 0,
        rateLimit: 0,
        enableDelete: true,
        saveDeletedLogs: false,
    });

    const offset = useRef(0);

    const [chatbotHtml, setChatbotHtml] = useState("");
    const [chatbotJs, setChatbotJs] = useState("");
    const [sourceFinderHtml, setSourceFinderHtml] = useState("");
    const [sourceFinderJs, setSourceFinderJs] = useState("");

    const [enableDelete, setEnableDelete] = useState(true);
    const [saveDeletedLogs, setSaveDeletedLogs] = useState(false);

    const handleSite = (event) => {
        setSiteName(event.trim());
    };

    const handleRateLimit = (event) => {
        if (event === "") {
            setRateLimit(0);
        } else {
            setRateLimit(event);
        }
    };

    const handleAutoTrainingInterval = (event) => {
        if (event === "") {
            setAutoTrainingInterval(0);
        } else {
            setAutoTrainingInterval(event);
        }
    };

    const handleBotName = (event) => {
        setBotName(event.trim());
    };

    const handleBannerUrl = (event) => {
        setBannerUrl(event.trim());
    };

    const handleEnableFileTrain = (event) => {
        setEnableFileTrain(event);
    };

    const handleEnableFullSiteTraining = (event) => {
        const boolValue = event === 'true';
        setEnableFullSiteTraining(boolValue);
    };

    const handleDomainUrl = (event) => {
        setDomainUrl(event.trim());
    };

    const [siteNameError, setSiteNameError] = useState('')
    const [rateLimitError, setRateLimitError] = useState('')
    const [autoTrainingIntervalError, setAutoTrainingIntervalError] = useState('')
    const [botNameError, setBotNameError] = useState('')
    const [bannerUrlError, setBannerUrlError] = useState('')
    const [domainUrlError, setDomainUrlError] = useState('')
    const [, setEnableFullSiteTrainingError] = useState(false)

    const validateSiteName = (event) => {
        event.preventDefault();
        const siteNamePattern = /^[ a-zA-Z0-9,-|()&]+$/;
        const specialCharPattern = /[^\w\s,-|()&]/g;
        const specialCharMatches = siteName.match(specialCharPattern);

        if (!siteNamePattern.test(siteName) || (specialCharMatches && specialCharMatches.length === 1)) {
            setSiteNameError(siteLabelC + " Name is invalid.");
        } else {
            setSiteNameError("");
        }
    }

    const validateRateLimit = (event) => {
        event.preventDefault();
        if (rateLimit < 0) {
            setRateLimitError("Rate Limit should not be less than 0.");
        } else {
            setRateLimitError("");
        }
    }

    const validateAutoTrainingInterval = (event) => {
        event.preventDefault();
        if (autoTrainingInterval < 0) {
            setAutoTrainingIntervalError("Auto Training Interval should not be less than 0.");
        } else if (autoTrainingInterval > 365) {
            setAutoTrainingIntervalError("Auto Training Interval should not be greater than 365 (1 year).");
        } else {
            setAutoTrainingIntervalError("");
        }
    }

    const validateBotName = (event) => {
        event.preventDefault();
        const botNamePattern = /^[ a-zA-Z0-9,-|()&]+$/;

        if (!botNamePattern.test(botName)) {
            setBotNameError("Bot Name is invalid");
        } else if (botName.length < 3) {
            setBotNameError("Bot Name should have atleast 3 Character");
        } else if (botName.length > 50) {
            setBotNameError("Bot Name should not exceed 50 Characters");
        } else {
            setBotNameError("");
        }
    }

    const validateBannerUrl = (event) => {
        event.preventDefault();
        const urlPattern = /^(http[s]?:\/\/)(www\.)?[^\s$.?#].[^\s]*$/;

        if (bannerUrl !== "" && !urlPattern.test(bannerUrl)) {
            setBannerUrlError("Banner URL is invalid");
        } else {
            setBannerUrlError("");
        }
    }

    const validateDomainUrl = (event) => {
        event.preventDefault();
        const urlPattern = /^(http[s]?:\/\/)(www\.)?[^\s$.?#].[^\s]*$/;

        if (domainUrl !== "" && !urlPattern.test(domainUrl)) {
            setDomainUrlError("Domain URL is invalid");
        } else {
            setDomainUrlError("");
        }
    }

    // Use ref to track initialization
    const initializedRef = useRef(false);

    // Add loading state — true immediately so Client page shows loader on navigate
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!token) {
            setIsLoading(false);
            history('/auth/sign-in');
            return;
        }

        // Check if user is active
        const checkUserActive = async () => {
            const requestOptions = {
                method: "GET",
                headers: { "accept": "application/json", "Authorization": "Bearer " + token },
            };

            try {
                const response = await fetch(userApi, requestOptions);
                const data = await response.json();
                if (data.is_active === false) {
                    clearAuthStorage();
                    window.location.href = '/auth/sign-in';
                    return;
                }
            } catch (err) {
                console.log("error", err);
                clearAuthStorage();
                window.location.href = '/auth/sign-in';
                return;
            }

            // Initialize data only once
            if (!initializedRef.current) {
                initializedRef.current = true;
                initializeData();
            }
        };

        checkUserActive();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, history]);

    const initializeData = async () => {
        setIsLoading(true);
        const headers = {
            "accept": "application/json",
            "Authorization": "Bearer " + token
        };

        const loggedInUserId = sessionStorage.getItem("loggedInUserId");

        try {
            // First, get page limit if not set
            let limit = 50; // default
            if (loggedInUserId && !sessionStorage.getItem("current_page_limit")) {
                try {
                    const pageLimitResponse = await axios.get(getPageLimitApi, {
                        headers: headers,
                        params: { user_id: loggedInUserId }
                    });
                    const pageLimitData = pageLimitResponse.data;
                    limit = pageLimitData.page_limit;
                    sessionStorage.setItem('current_page_limit', limit);
                    sessionStorage.setItem('previous_page_limit', limit);
                } catch (pageLimitErr) {
                    console.error("Error fetching page limit:", pageLimitErr);
                }
            } else {
                limit = parseInt(sessionStorage.getItem("current_page_limit")) || 50;
            }

            setItemsPerPage(limit);

            // Then fetch site data only once
            const skip = 0;
            const response = await axios.get(userSiteApi, {
                headers: headers,
                params: { skip, limit }
            });

            const data = response.data;

            const userSites = data.data.map(element => element);
            setUserSiteData(userSites);
            setFilteredSiteData(userSites);
            setSiteCount(data.total_count);

        } catch (err) {
            if (err.response) {
                if (err.response.status === 401) {
                    clearAuthStorage();
                    window.location.href = '/auth/sign-in';
                } else {
                    error(err.response.data.detail, true);
                }
            } else if (err.message === 'ERR_NETWORK') {
                error(ERR_NETWORK_MESSAGE, true);
            } else {
                console.error(err);
            }
            history('/dashboard');
        } finally {
            setIsLoading(false);
        }
    }

    // Search functionality
    const [searchInputValue, setSearchInputValue] = useState("");
    const [showClearButton, setShowClearButton] = useState(false);

    const handleSearch = () => {
        if (searchInputValue.trim() !== "") {
            setShowClearButton(true);
        }
        setCurrentPage(1);
        setCurrentRangeStart(1);
        const newOffset = 0;
        offset.current = newOffset;
        fetchDataWithPagination(newOffset, searchInputValue, activeStatusFilter);
    };

    const handleClearSearch = () => {
        setSearchInputValue("");
        setShowClearButton(false);
        setCurrentPage(1);
        setCurrentRangeStart(1);
        const newOffset = 0;
        offset.current = newOffset;
        fetchDataWithPagination(newOffset, "", activeStatusFilter);
    };

    const addSite = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            var data = JSON.stringify({
                "name": siteName,
                "rate_limit": rateLimit,
                "bot_name": botName,
                "banner_url": bannerUrl.length > 0 ? bannerUrl : defaultBanenrURL,
                "domain_url": domainUrl.length > 0 ? domainUrl : '',
                "qdrant_db_url": qdrantDbUrl,
                "auto_training_interval": autoTrainingInterval,
                "enable_full_site_training": enableFullSiteTraining,
                "enable_delete": enableDelete,
                "save_deleted_logs": saveDeletedLogs,
            });

            axios.post(addSiteApi, data, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    setUserSiteData(oldData => [...oldData, data]);
                    setFilteredSiteData(oldData => [...oldData, data]);
                    setSiteCount(prev => prev + 1);
                    success(siteLabelC + " added successfully.", true);
                    setSiteName("");
                    setRateLimit(0);
                    setBotName("");
                    setAutoTrainingInterval(0);
                    setEnableFullSiteTraining(false);
                    setEnableDelete(true);
                    setSaveDeletedLogs(false);
                    handleCloseAddSite();
                })
                .catch((err) => {
                    if (err.code === 'ERR_NETWORK' || err.message === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true);
                    } else if (err.response && err.response.data && err.response.data.detail) {
                        error(err.response.data.detail, true);
                    } else {
                        error("An unexpected error occurred. Please try again.", true);
                    }
                });
        }
    };

    const editSite = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };

            const hasChanged = siteName !== currentSiteInfo.siteName ||
                rateLimit !== currentSiteInfo.rateLimit ||
                botName !== currentSiteInfo.botName ||
                bannerUrl !== currentSiteInfo.bannerUrl ||
                enableFileTrain !== currentSiteInfo.enableFileTrain ||
                domainUrl !== currentSiteInfo.domainUrl ||
                qdrantDbUrl !== currentSiteInfo.qdrantDbUrl ||
                enableFullSiteTraining !== currentSiteInfo.enableFullSiteTraining ||
                autoTrainingInterval !== currentSiteInfo.autoTrainingInterval ||
                enableDelete !== currentSiteInfo.enableDelete ||
                saveDeletedLogs !== currentSiteInfo.saveDeletedLogs

            if (hasChanged) {
                var data = JSON.stringify({
                    "website_request": {
                        "name": siteName,
                        "rate_limit": rateLimit,
                        "bot_name": botName,
                        "banner_url": bannerUrl,
                        "enable_file_train": enableFileTrain,
                        "domain_url": domainUrl,
                        "qdrant_db_url": qdrantDbUrl,
                        "enable_full_site_training": enableFullSiteTraining,
                        "auto_training_interval": autoTrainingInterval,
                        "enable_delete": enableDelete,
                        "save_deleted_logs": saveDeletedLogs
                    }
                });

                axios.put(editSiteApi + siteId, data, { headers: headers })
                    .then((response) => {
                        setCurrentSiteInfo({
                            siteName: siteName,
                            botName: botName,
                            domainUrl: domainUrl,
                            bannerUrl: bannerUrl,
                            enableFullSiteTraining: enableFullSiteTraining,
                            enableFileTrain: enableFileTrain,
                            autoTrainingInterval: autoTrainingInterval,
                            rateLimit: rateLimit,
                            enableDelete: enableDelete,
                            saveDeletedLogs: saveDeletedLogs,
                        });

                        setUserSiteData(
                            userSiteData.filter((val) => {
                                return val.id !== siteId;
                            })
                        );
                        updateUserSiteData(siteId);
                        success(siteLabelC + " updated successfully.", true);
                        handleCloseEditSite();
                    })
                    .catch((err) => {
                        if (err === 'ERR_NETWORK') {
                            error(ERR_NETWORK_MESSAGE, true);
                        } else {
                            error(err.response.data.detail, true);
                        }
                    });
            } else {
                error("No changes detected to update.", true);
                handleCloseEditSite();
            }
        }
    };

    const trainFullSite = () => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };

        axios.post(fullSiteTrainingApi + siteId, { headers: headers })
            .then((response) => {
                info("Full Site Training request received for " + siteLabelC + ". Configured Admin and Site Admin will be notified through email once the process is completed.", true);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true)
                } else {
                    error(err.response.data.detail, false)
                }
            });

        setShowFSTConfirm(false);
    };

    const deleteSite = () => {
        const headers = { "accept": "application/json", "Authorization": "Bearer " + token };

        axios.delete(deleteSiteApi + siteId, { data: { "websiteRef": key } }, { headers: headers })
            .then((response) => {
                const data = response.data;
                success(getApiMessage(data, siteLabelC + " deleted successfully."), true);
                setUserSiteData(
                    userSiteData.filter((val) => {
                        return val.id !== siteId;
                    })
                );
                setFilteredSiteData(
                    filteredSiteData.filter((val) => {
                        return val.id !== siteId;
                    })
                );
                setSiteCount(prev => prev - 1);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true)
                } else {
                    const detail = err && err.response && err.response.data
                        ? err.response.data.detail || err.response.data.message || err.response.data
                        : null;
                    error(detail || "Unable to delete " + siteLabel, true)
                }
            });

        setShowDeleteSite(false);

        setSiteName("");
        setRateLimit(0);
        setBotName("");
        setAutoTrainingInterval(0);
        setEnableFullSiteTraining(false);
        setEnableDelete(true);
        setSaveDeletedLogs(false);
    };

    const updateUserSiteData = (id) => {
        const currentSiteIndex = userSiteData.findIndex((site) => site.id === id);
        const updatedSite = Object.assign({}, userSiteData[currentSiteIndex]);
        updatedSite.name = siteName;
        updatedSite.rate_limit = rateLimit;
        updatedSite.bot_name = botName;
        updatedSite.banner_url = bannerUrl;
        updatedSite.enable_file_train = enableFileTrain;
        updatedSite.domain_url = domainUrl;
        updatedSite.enable_full_site_training = enableFullSiteTraining;
        updatedSite.auto_training_interval = autoTrainingInterval;
        updatedSite.enable_delete = enableDelete;
        updatedSite.save_deleted_logs = saveDeletedLogs;
        const newUserSiteData = userSiteData.slice();
        newUserSiteData[currentSiteIndex] = updatedSite;
        setUserSiteData(newUserSiteData);

        // Also update filtered data
        const filteredSiteIndex = filteredSiteData.findIndex((site) => site.id === id);
        if (filteredSiteIndex !== -1) {
            const newFilteredSiteData = filteredSiteData.slice();
            newFilteredSiteData[filteredSiteIndex] = updatedSite;
            setFilteredSiteData(newFilteredSiteData);
        }
    };

    const HtmlContentDisplay = ({ htmlContent }) => {
        return <pre>{htmlContent}</pre>;
    };

    const areAllFieldsFilled = siteName !== "" && botName !== "" && siteNameError === "" && botNameError === "" && bannerUrlError === "" && autoTrainingIntervalError === "" && domainUrlError === "" && rateLimitError === "";

    useEffect(() => {
        if (showAddSite) {
            setSiteName("")
            setBotName("")
            setSiteNameError("")
            setBotNameError("")
            setBannerUrlError("")
        }
    }, [showAddSite]);

    const [itemsPerPage, setItemsPerPage] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentRangeStart, setCurrentRangeStart] = useState(1);
    const pagesToShow = 10;

    // Use filtered data for pagination
    const totalPages = itemsPerPage ? Math.ceil(siteCount / itemsPerPage) : 0;

    const paginate = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Single useEffect for pagination
    useEffect(() => {
        if (initializedRef.current) {
            const offset = (currentPage - 1) * itemsPerPage;
            fetchDataWithPagination(offset);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    const fetchDataWithPagination = async (offset, searchText = "", statusFilter = activeStatusFilter) => {
        setIsLoading(true);
        const headers = { accept: "application/json", Authorization: "Bearer " + token };

        try {
            const params = { skip: offset, limit: itemsPerPage };

            if (searchText && searchText.trim() !== "") params.search_text = searchText.trim();
            if (statusFilter && statusFilter !== "all") params.active_status = statusFilter; // <-- new

            const response = await axios.get(userSiteApi, { headers, params });
            const data = response.data;

            const userSites = data.data.map((element) => element);
            setUserSiteData(userSites);
            setFilteredSiteData(userSites);
            setSiteCount(data.total_count);
        } catch (err) {
            if (err.response) {
                if (err.response.status === 401) {
                    clearAuthStorage();
                    window.location.href = '/auth/sign-in';
                } else {
                    error(err.response.data.detail, true);
                }
            } else if (err.message === 'ERR_NETWORK') {
                error(ERR_NETWORK_MESSAGE, true);
            } else {
                console.error(err);
            }
        }
        finally {
            setIsLoading(false);
        }
    };


    const handlePrevRange = () => {
        setCurrentRangeStart(prev => Math.max(prev - pagesToShow, 1));
    };

    const handleNextRange = () => {
        setCurrentRangeStart(prev => Math.min(prev + pagesToShow, totalPages));
    };

    const visiblePageNumbers = [];
    for (let i = currentRangeStart; i < Math.min(currentRangeStart + pagesToShow, totalPages + 1); i++) {
        visiblePageNumbers.push(i);
    }

    const handleItemsPerPageChange = (e) => {
        const newItemsPerPage = parseInt(e.target.value, 10);
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1);

        // Update page limit in backend
        updatePageLimit(newItemsPerPage);
    };

    const updatePageLimit = async (newLimit) => {
        setIsLoading(true);
        const headers = {
            "accept": "application/json",
            "Authorization": "Bearer " + token
        };
        const loggedInUserId = sessionStorage.getItem("loggedInUserId");

        try {
            await axios.post(setPageLimitURL,
                {
                    page_limit: newLimit
                },
                {
                    headers: headers,
                    params: { user_id: loggedInUserId }
                }
            );

            sessionStorage.setItem('current_page_limit', newLimit);
            sessionStorage.setItem('previous_page_limit', newLimit);

            // Refresh data with new limit
            const offset = 0;
            const response = await axios.get(userSiteApi, {
                headers: headers,
                params: { skip: offset, limit: newLimit }
            });

            const data = response.data;
            const userSites = data.data.map(element => element);
            setUserSiteData(userSites);
            setFilteredSiteData(userSites);
            setSiteCount(data.total_count);

        } catch (setLimitErr) {
            console.error('Error setting page limit:', setLimitErr);
            error('Error setting page limit', true);
        } finally {
            setIsLoading(false);
        }
    };

    const [qdrantDbUrl, setQdrantDbUrl] = useState('');
    const [qdrantDbUrlError, setQdrantDbUrlError] = useState('');

    const validateQdrantDbUrl = (event) => {
        event.preventDefault();
        const urlPattern = /^(http[s]?:\/\/)(www\.)?[^\s$.?#].[^\s]*$/;

        if (!urlPattern.test(qdrantDbUrl)) {
            setQdrantDbUrlError("Qdrant DB URL is invalid");
        } else {
            setQdrantDbUrlError("");
        }
    };

    const [activeTab, setActiveTab] = useState("chatbot");
    const [availableIcons, setAvailableIcons] = useState([]);
    const [availableChatbotMessageIcons, setAvailableChatbotMessageIcons] = useState([]);
    const [isChatbotIconUploading, setIsChatbotIconUploading] = useState(false);
    const [isChatbotMessageIconUploading, setIsChatbotMessageIconUploading] = useState(false);
    const fileInputRef = useRef(null);

    const [activeStatusFilter, setActiveStatusFilter] = useState("all");
    const [isExporting, setIsExporting] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [exportStatusFilter, setExportStatusFilter] = useState("all");

    const handleOpenExportModal = () => {
        if (isExporting || isLoading) {
            return;
        }
        setExportStatusFilter(activeStatusFilter || "all");
        setShowExportModal(true);
    };

    const handleCloseExportModal = () => {
        if (isExporting) {
            return;
        }
        setShowExportModal(false);
    };

    const handleExportClients = async () => {
        if (isExporting) {
            return;
        }

        setIsExporting(true);
        try {
            const statusToExport = exportStatusFilter || "all";
            const params = new URLSearchParams({
                active_status: statusToExport,
            });
            if (searchInputValue && searchInputValue.trim() !== "") {
                params.set("search_text", searchInputValue.trim());
            }

            const url = `${process.env.REACT_APP_SERVER_URL}/api/website/export?${params}`;
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.detail || "Export failed");
            }

            const contentDisposition = response.headers.get("Content-Disposition");
            let filename = `clients_${statusToExport}.xlsx`;
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/i);
                if (match) {
                    filename = match[1];
                }
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

            success("Export completed successfully", true);
            setShowExportModal(false);
        } catch (err) {
            console.error("Export error:", err);
            error(err.message || "Failed to export client list", true);
        } finally {
            setIsExporting(false);
        }
    };

    const fetchIcons = async (iconType = "CHATBOT_LOGO") => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/api/website/assets/icons?icon_type=${iconType}`,
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            );
            return response.data.icons;
        } catch (err) {
            console.error("Error loading icons:", err);
            error(err.response?.data?.detail || "Failed to load icons", true);
            return [];
        }
    };

    useEffect(() => {
        if (token && showSiteScript) {
            const loadIcons = async () => {
                const chatbotIcons = await fetchIcons("CHATBOT_LOGO");
                const messageIcons = await fetchIcons("CHATBOT_MESSAGE_ICON");
                // Combine both icon lists (they should be the same)
                if (chatbotIcons.length > 0) {
                    setAvailableIcons(chatbotIcons);
                }
                if (messageIcons.length > 0) {
                    setAvailableChatbotMessageIcons(messageIcons);
                }
            };
            loadIcons();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, showSiteScript]);

    const handleFileUpload = async (event, iconType = "CHATBOT_LOGO") => {
        const file = event.target.files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!validTypes.includes(file.type)) {
            error('Invalid file type. Only PNG/JPG allowed.', true);
            return;
        }

        // Set loading states
        if (iconType === "CHATBOT_LOGO") {
            setIsChatbotIconUploading(true);
        } else {
            setIsChatbotMessageIconUploading(true);
        }

        const formData = new FormData();
        formData.append('icon', file);
        formData.append('icon_type', iconType);
        formData.append('website_ref', botScriptKey);

        try {
            const response = await axios.post(
                uploadIconApi,
                formData,
                {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                }
            );

            if (response.data.icon) {
                // 1. Fetch updated icons list to include new upload
                const icons = await fetchIcons(iconType);

                // 2. Determine correct field name for site data update
                const fieldName = iconType === "CHATBOT_LOGO"
                    ? "chatbot_icon_name"
                    : "chatbot_message_icon_name";

                // 3. CRITICAL FIX: Update site data arrays to persist selection
                // This ensures correct preview when modal reopens
                setUserSiteData(prev => prev.map(site =>
                    site.key === botScriptKey
                        ? { ...site, [fieldName]: response.data.icon }
                        : site
                ));

                setFilteredSiteData(prev => prev.map(site =>
                    site.key === botScriptKey
                        ? { ...site, [fieldName]: response.data.icon }
                        : site
                ));

                // 4. Update local preview states
                if (iconType === "CHATBOT_LOGO") {
                    setAvailableIcons(icons);
                    setSelectedIcon(response.data.icon);
                } else {
                    setAvailableChatbotMessageIcons(icons);
                    setSelectedMessageIcon(response.data.icon);
                }

                success('Icon uploaded successfully', true);
            }
        } catch (err) {
            console.error('Upload error:', err);
            error(err.response?.data?.detail || 'Upload failed', true);
        } finally {
            // Reset loading states
            if (iconType === "CHATBOT_LOGO") {
                setIsChatbotIconUploading(false);
            } else {
                setIsChatbotMessageIconUploading(false);
            }

            // Reset file input ONLY for chatbot logo (ref-based upload)
            // Message icon uses dynamic input that self-destructs
            if (iconType === "CHATBOT_LOGO" && fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };


    // Status Style Helper Function with Fixed Width
    const getStatusStyle = (type) => {
        let borderColor, bgColor, textColor;
        switch (type) {
            case "trained":
                borderColor = "#28a745";
                bgColor = "#d4edda";
                textColor = "#155724";
                break;
            case "pending":
                borderColor = "#ffc107";
                bgColor = "#fff3cd";
                textColor = "#856404";
                break;
            case "failed":
                borderColor = "#dc3545";
                bgColor = "#f8d7da";
                textColor = "#721c24";
                break;
            default:
                borderColor = "#6c757d";
                bgColor = "#f8f9fa";
                textColor = "#6c757d";
        }
        return {
            border: `1px solid ${borderColor}`,
            backgroundColor: bgColor,
            color: textColor,
            borderRadius: '4px',
            padding: '2px 4px',
            fontSize: '11px',
            fontWeight: 600,
            cursor: 'default',
            display: 'inline-block',
            margin: '1px',
            width: '38px',
            height: '24px',
            textAlign: 'center',
            lineHeight: '18px',
            boxSizing: 'border-box'
        };
    };

    // Icons (keeping all existing icons the same)
    const EditIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.7476 20.4428H21.0002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M12.78 3.79479C13.5557 2.86779 14.95 2.73186 15.8962 3.49173C15.9485 3.53296 17.6295 4.83879 17.6295 4.83879C18.669 5.46719 18.992 6.80311 18.3494 7.82259C18.3153 7.87718 8.81195 19.7645 8.81195 19.7645C8.49578 20.1589 8.01583 20.3918 7.50291 20.3973L3.86353 20.443L3.04353 16.9723C2.92866 16.4843 3.04353 15.9718 3.3597 15.5773L12.78 3.79479Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.021 6.00098L16.4732 10.1881" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const DocumentsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.7161 16.2234H8.49609" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.7161 12.0369H8.49609" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.2521 7.86011H8.49707" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M15.909 2.74976C15.909 2.74976 8.23198 2.75376 8.21998 2.75376C5.45998 2.77076 3.75098 4.58676 3.75098 7.35676V16.5528C3.75098 19.3368 5.47298 21.1598 8.25698 21.1598C8.25698 21.1598 15.933 21.1568 15.946 21.1568C18.706 21.1398 20.416 19.3228 20.416 16.5528V7.35676C20.416 4.57276 18.693 2.74976 15.909 2.74976Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const DeleteIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const ExternalSitesIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 7H16.5C17.3284 7 18 7.67157 18 8.5V15.5C18 16.3284 17.3284 17 16.5 17H7.5C6.67157 17 6 16.3284 6 8.5C6 7.67157 6.67157 7 7.5 7H10" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 12L14 8M14 8L18 12M14 8V15" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const ManageUserIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.8877 10.8967C19.2827 10.7007 20.3567 9.50473 20.3597 8.05573C20.3597 6.62773 19.3187 5.44373 17.9537 5.21973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.7285 14.2505C21.0795 14.4525 22.0225 14.9255 22.0225 15.9005C22.0225 16.5715 21.5785 17.0075 20.8605 17.2815" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11.8867 14.6638C8.67273 14.6638 5.92773 15.1508 5.92773 17.0958C5.92773 19.0398 8.65573 19.5408 11.8867 19.5408C15.1007 19.5408 17.8447 19.0588 17.8447 17.1128C17.8447 15.1668 15.1177 14.6638 11.8867 14.6638Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11.8869 11.888C13.9959 11.888 15.7059 10.179 15.7059 8.069C15.7059 5.96 13.9959 4.25 11.8869 4.25C9.7779 4.25 8.0679 5.96 8.0679 8.069C8.0599 10.171 9.7569 11.881 11.8589 11.888H11.8869Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.88509 10.8967C4.48909 10.7007 3.41609 9.50473 3.41309 8.05573C3.41309 6.62773 4.45409 5.44373 5.81909 5.21973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.044 14.2505C2.693 14.4525 1.75 14.9255 1.75 15.9005C1.75 16.5715 2.194 17.0075 2.912 17.2815" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const ManageCategoryIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3 6.5C3 3.87479 3.02811 3 6.5 3C9.97189 3 10 3.87479 10 6.5C10 9.12521 10.0111 10 6.5 10C2.98893 10 3 9.12521 3 6.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14 6.5C14 3.87479 14.02811 3 17.5 3C20.9719 3 21 3.87479 21 6.5C21 9.12521 21.0111 10 17.5 10C13.9889 10 14 9.12521 14 6.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M3 17.5C3 14.8748 3.02811 14 6.5 14C9.97189 14 10 14.8748 10 17.5C10 20.1252 10.0111 21 6.5 21C2.98893 21 3 20.1252 3 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14 17.5C14 14.8748 14.02811 14 17.5 14C20.9719 14 21 14.8748 21 17.5C21 20.1252 21.0111 21 17.5 21C13.9889 21 14 20.1252 14 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const FullSiteTrainingIcon = () => (
        <svg width="16" height="16" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="2" stroke="currentColor" fill="none">
            <path d="M39.93,55.72A24.86,24.86,0,1,1,56.86,32.15a37.24,37.24,0,0,1-.73,6" />
            <path d="M37.86,51.1A47,47,0,0,1,32,56.7" />
            <path d="M32,7A34.14,34.14,0,0,1,43.57,30a34.07,34.07,0,0,1,.09,4.85" />
            <path d="M32,7A34.09,34.09,0,0,0,20.31,32.46c0,16.2,7.28,21,11.66,24.24" />
            <line x1="10.37" y1="19.9" x2="53.75" y2="19.9" />
            <line x1="32" y1="6.99" x2="32" y2="56.7" />
            <line x1="11.05" y1="45.48" x2="37.04" y2="45.48" />
            <line x1="7.14" y1="32.46" x2="56.86" y2="31.85" />
            <path d="M53.57,57,58,52.56l-8-8,4.55-2.91a.38.38,0,0,0-.12-.7L39.14,37.37a.39.39,0,0,0-.46.46L42,53.41a.39.39,0,0,0,.71.13L45.57,49Z" />
        </svg>
    );

    const TestChatbotIcon = () => (
        <svg width="16" height="16" viewBox="0 0 60 60" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M55.894,37.041C58.582,33.27,60,28.912,60,24.414C60,11.504,48.337,1,34,1c-9.871,0-18.998,5.142-23.344,13.114 C4.201,18.379,0,25.255,0,33c0,4.498,1.418,8.855,4.106,12.627c-0.51,5.577-1.859,9.712-3.813,11.666 c-0.304,0.304-0.38,0.769-0.188,1.153C0.275,58.789,0.625,59,1,59c0.046,0,0.092-0.003,0.139-0.01 c0.35-0.049,8.433-1.213,14.317-4.586c3.33,1.334,6.875,2.01,10.544,2.01c8.525,0,16.104-3.714,20.848-9.44 c5.511,2.486,11.738,3.392,12.012,3.43c0.047,0.007,0.094,0.01,0.14,0.01c0.375,0,0.724-0.211,0.895-0.554 c0.192-0.385,0.117-0.85-0.188-1.153C57.753,46.753,56.403,42.618,55.894,37.041z M26,54.414c-2.891,0-5.694-0.458-8.364-1.348 c3.334-2.09,3.337-2.255,3.335-2.821c-0.002-0.349-0.189-0.68-0.488-0.86c-0.451-0.272-1.026-0.146-1.328,0.271 c-0.493,0.386-2.508,1.677-4.302,2.783c-3.701,2.233-8.639,3.513-11.55,4.123C5.1,53.389,5.837,48.94,6.131,45.426 c0.021-0.241-0.048-0.481-0.191-0.677C3.362,41.254,2,37.191,2,33c0-7.221,4.031-13.614,10.186-17.495 c0.384-0.242,0.773-0.475,1.17-0.695c0.094-0.052,0.187-0.106,0.282-0.157c0.418-0.225,0.845-0.435,1.275-0.636 c0.158-0.074,0.317-0.147,0.477-0.218c0.44-0.194,0.884-0.379,1.335-0.548c0.157-0.059,0.318-0.112,0.477-0.168 c0.356-0.126,0.716-0.244,1.078-0.354c0.166-0.051,0.331-0.104,0.499-0.151c0.47-0.133,0.946-0.251,1.425-0.357 c0.167-0.037,0.335-0.07,0.503-0.104c0.431-0.087,0.865-0.164,1.302-0.23c0.101-0.015,0.2-0.034,0.302-0.048 c0.528-0.073,1.061-0.126,1.596-0.167c0.139-0.011,0.279-0.02,0.419-0.029c0.555-0.034,1.113-0.058,1.674-0.058 c13.233,0,24,9.606,24,21.414c0,0.483-0.025,0.964-0.061,1.443c-0.009,0.125-0.02,0.249-0.032,0.374 c-0.042,0.443-0.095,0.884-0.167,1.321c-0.006,0.037-0.01,0.075-0.016,0.113c-0.078,0.457-0.179,0.909-0.29,1.358 c-0.034,0.138-0.07,0.275-0.107,0.413c-0.107,0.396-0.224,0.789-0.356,1.178c-0.035,0.102-0.07,0.205-0.107,0.306 c-0.136,0.381-0.287,0.757-0.447,1.131c-0.064,0.149-0.13,0.298-0.197,0.446c-0.179,0.391-0.367,0.778-0.573,1.16 c-0.06,0.111-0.125,0.219-0.187,0.329c-0.18,0.32-0.37,0.636-0.568,0.949c-0.087,0.137-0.174,0.275-0.265,0.41 c-0.247,0.369-0.504,0.734-0.777,1.091C41.528,50.686,34.243,54.414,26,54.414z M48.094,45.343c0.041-0.06,0.076-0.122,0.116-0.182 c0.233-0.344,0.456-0.693,0.669-1.048c0.12-0.2,0.231-0.402,0.344-0.605c0.123-0.219,0.243-0.44,0.358-0.664 c0.106-0.206,0.212-0.412,0.312-0.62c0.147-0.308,0.285-0.621,0.418-0.936c0.102-0.242,0.197-0.485,0.29-0.73 c0.107-0.28,0.209-0.562,0.304-0.847c0.063-0.191,0.124-0.382,0.182-0.574c0.094-0.311,0.179-0.626,0.259-0.942 c0.036-0.144,0.078-0.286,0.111-0.431c0.103-0.448,0.19-0.902,0.264-1.36c0.023-0.142,0.041-0.286,0.061-0.429 c0.05-0.355,0.092-0.713,0.124-1.073c0.013-0.145,0.027-0.29,0.037-0.435C51.977,33.981,52,33.493,52,33 C52,20.09,40.337,9.586,26,9.586c-0.479,0-0.955,0.014-1.428,0.037c-0.172,0.008-0.342,0.024-0.513,0.035 c-0.298,0.02-0.595,0.04-0.89,0.069c 0.213,0.021-0.424,0.048-0.635,0.073c-0.247,0.03-0.494,0.06-0.739,0.096 c-0.236,0.034-0.47,0.073-0.704,0.114c-0.212,0.037-0.423,0.075-0.634,0.117c-0.255,0.05-0.509,0.102-0.761,0.159 c-0.177,0.04-0.353,0.083-0.529,0.127c-0.276,0.068-0.552,0.135-0.824,0.211c-0.121,0.034-0.24,0.072-0.361,0.107 c-1.046,0.306-2.07,0.671-3.068,1.096c-0.071,0.03-0.143,0.058-0.214,0.089c-0.091,0.04-0.184,0.074-0.275,0.115 C18.883,6.45,26.186,3,34,3c13.233,0,24,9.606,24,21.414c0,4.191-1.362,8.254-3.939,11.749c-0.144,0.195-0.212,0.436-0.191,0.677 c0.294,3.513,1.031,7.961,2.828,11.135C54.511,47.516,51.181,46.677,48.094,45.343z" />
            <path d="M13,29c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S15.206,29,13,29z M13,35c-1.103,0-2-0.897-2-2c0-1.103,0.897-2,2-2 s2,0.897,2,2C15,34.103,14.103,35,13,35z" />
            <path d="M26,29c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S28.206,29,26,29z M26,35c-1.103,0-2-0.897-2-2c0-1.103,0.897-2,2-2 s2,0.897,2,2C28,34.103,27.103,35,26,35z" />
            <path d="M39,29c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S41.206,29,39,29z M39,35c-1.103,0-2-0.897-2-2c0-1.103,0.897-2,2-2 s2,0.897,2,2C41,34.103,40.103,35,39,35z" />
        </svg>
    );

    const CustomizeChatIcon = () => (
        <svg width="16" height="16" viewBox="0 -2 50 50" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
            <path d="M0 0 C1.2219104 0.00607269 1.2219104 0.00607269 2.46850586 0.01226807 C3.30438232 0.01035461 4.14025879 0.00844116 5.00146484 0.00646973 C6.77010397 0.00510771 8.53875309 0.0088053 10.30737305 0.01715088 C13.02016579 0.02785031 15.7322963 0.01725631 18.44506836 0.00445557 C20.16121566 0.00577716 21.87736255 0.00833955 23.59350586 0.01226807 C24.40811279 0.0082196 25.22271973 0.00417114 26.06201172 0 C31.80108658 0.04797379 31.80108658 0.04797379 34.03100586 2.27789307 C34.28979492 5.41070557 34.28979492 5.41070557 34.29663086 9.40289307 C34.29950104 10.45694336 34.29950104 10.45694336 34.3024292 11.5322876 C34.30379061 13.0184566 34.30009718 14.50463751 34.29174805 15.99078369 C34.2810474 18.26904952 34.29164425 20.54652684 34.30444336 22.82476807 C34.30312176 24.26747814 34.30055935 25.71018773 34.29663086 27.15289307 C34.294375 28.47031494 34.29211914 29.78773682 34.28979492 31.14508057 C34.03100586 34.27789307 34.03100586 34.27789307 32.03100586 36.27789307 C29.78442383 36.50494385 29.78442383 36.50494385 27.02319336 36.47320557 C26.03706055 36.46676025 25.05092773 36.46031494 24.03491211 36.45367432 C23.00237305 36.4369165 21.96983398 36.42015869 20.90600586 36.40289307 C19.86573242 36.39386963 18.82545898 36.38484619 17.75366211 36.37554932 C15.17921494 36.35193053 12.60522374 36.31899456 10.03100586 36.27789307 C9.73709961 37.06551025 9.44319336 37.85312744 9.14038086 38.66461182 C7.84553489 41.71479475 6.9487452 42.73797508 4.03100586 44.27789307 C0.78100586 44.46539307 0.78100586 44.46539307 -1.96899414 44.27789307 C-0.96899414 40.27789307 -0.96899414 40.27789307 0.03100586 36.27789307 C-0.91774414 36.31914307 -1.86649414 36.36039307 -2.84399414 36.40289307 C-5.96899414 36.27789307 -5.96899414 36.27789307 -7.96899414 34.27789307 C-8.2277832 31.14508057 -8.2277832 31.14508057 -8.23461914 27.15289307 C-8.23653259 26.45019287 -8.23844604 25.74749268 -8.24041748 25.02349854 C-8.24177889 23.53732953 -8.23808546 22.05114862 -8.22973633 20.56500244 C-8.21903568 18.28673661 -8.22963253 16.0092593 -8.24243164 13.73101807 C-8.24111004 12.28830799 -8.23854763 10.8455984 -8.23461914 9.40289307 C-8.23236328 8.08547119 -8.23010742 6.76804932 -8.2277832 5.41070557 C-7.75800806 -0.27623277 -5.06635498 0.04235042 0 0 Z M-4.89331055 3.43560791 C-6.42777248 6.06362647 -6.35769929 8.1201071 -6.36743164 11.15289307 C-6.37129883 12.30273682 -6.37516602 13.45258057 -6.37915039 14.63726807 C-6.36754883 15.83867432 -6.35594727 17.04008057 -6.34399414 18.27789307 C-6.3555957 19.47929932 -6.36719727 20.68070557 -6.37915039 21.91851807 C-6.3752832 23.06836182 -6.37141602 24.21820557 -6.36743164 25.40289307 C-6.36404785 26.45734619 -6.36066406 27.51179932 -6.35717773 28.59820557 C-6.17685071 31.28684676 -6.17685071 31.28684676 -4.64331055 33.13336182 C-2.13442218 34.84839078 0.07870207 34.47471332 3.03100586 34.27789307 C3.03100586 36.25789307 3.03100586 38.23789307 3.03100586 40.27789307 C5.09091064 38.9832163 5.09091064 38.9832163 7.03100586 37.27789307 C7.03100586 36.28789307 7.03100586 35.29789307 7.03100586 34.27789307 C8.00710815 34.30145874 8.00710815 34.30145874 9.00292969 34.32550049 C11.9497001 34.38783956 14.89633184 34.4268799 17.84350586 34.46539307 C19.37974609 34.50309814 19.37974609 34.50309814 20.94702148 34.54156494 C21.92993164 34.55123291 22.9128418 34.56090088 23.92553711 34.57086182 C24.83150635 34.58657227 25.73747559 34.60228271 26.67089844 34.61846924 C29.04814935 34.44175861 29.04814935 34.44175861 30.82519531 33.12677002 C32.53519665 30.50481413 32.41944683 28.51800089 32.42944336 25.40289307 C32.43331055 24.25304932 32.43717773 23.10320557 32.44116211 21.91851807 C32.42956055 20.71711182 32.41795898 19.51570557 32.40600586 18.27789307 C32.41760742 17.07648682 32.42920898 15.87508057 32.44116211 14.63726807 C32.43729492 13.48742432 32.43342773 12.33758057 32.42944336 11.15289307 C32.42605957 10.09843994 32.42267578 9.04398682 32.41918945 7.95758057 C32.20757722 5.31571978 32.20757722 5.31571978 30.95532227 3.43560791 C27.96109207 1.6342073 25.30816106 1.88843357 21.84350586 1.87945557 C21.14459229 1.87658539 20.44567871 1.87371521 19.72558594 1.87075806 C18.24958485 1.86871881 16.77355665 1.87423904 15.29760742 1.88677979 C13.03885448 1.90283727 10.78189068 1.88692836 8.52319336 1.86773682 C7.08829358 1.86971928 5.65339491 1.87356301 4.21850586 1.87945557 C2.91268555 1.88283936 1.60686523 1.88622314 0.26147461 1.88970947 C-2.87593696 2.0429897 -2.87593696 2.0429897 -4.89331055 3.43560791 Z " transform="translate(11.968994140625,2.72210693359375)" />
            <path d="M0 0 C3.3721049 1.44518781 5.69880363 3.12350453 8 6 C8.25 8.75 8.25 8.75 8 11 C5.875 11.375 5.875 11.375 3 11 C0.76086748 9.20659643 -1.12454539 7.16547337 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z " transform="translate(29,22)" />
            <path d="M0 0 C2.65664779 0.15180845 4.45217862 0.52011425 6.48046875 2.296875 C7.875 3.875 7.875 3.875 10 7 C9.67 7.99 9.34 8.98 9 10 C5.55261628 8.46782946 2.74690118 6.59429556 0 4 C0 2.68 0 1.36 0 0 Z " transform="translate(13,9)" />
        </svg>
    );

    const ChatHistoryIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 3H7C4.79086 3 3 4.79086 3 7V15C3 17.2091 4.79086 19 7 19H17C19.2091 19 21 17.2091 21 15V7C21 4.79086 19.2091 3 17 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 8H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 12H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 16H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const GenerateScriptIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24" fill="black">
                <rect fill="white" x="3" width="18" height="24" />
                <path d="M4 3.00004C4 1.89547 4.89543 1.00004 6 1.00004H13.0801C13.664 1.00004 14.2187 1.25517 14.5986 1.69845L19.5185 7.43826C19.8292 7.80075 20 8.26243 20 8.73985V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V3.00004Z" />
            </mask>
            <path d="M4 3.00004C4 1.89547 4.89543 1.00004 6 1.00004H13.0801C13.664 1.00004 14.2187 1.25517 14.5986 1.69845L19.5185 7.43826C19.8292 7.80075 20 8.26243 20 8.73985V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V3.00004Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-1-outside-1)" />
            <path id="Rectangle 21" d="M14 6V0L21 8H16C14.8954 8 14 7.10457 14 6Z" stroke="currentColor" />
            <mask id="path-4-inside-3" fill="white">
                <path fillRule="evenodd" clipRule="evenodd" d="M7 14.5945L8.99429 12.1334C9.12172 11.9761 9.34898 11.9549 9.50189 12.0859C9.6548 12.217 9.67546 12.4507 9.54804 12.6079L7.93828 14.5945L9.54804 16.581C9.67546 16.7383 9.6548 16.972 9.50189 17.103C9.34898 17.2341 9.12172 17.2128 8.99429 17.0556L7 14.5945Z" />
            </mask>
            <path fillRule="evenodd" clipRule="evenodd" d="M7 14.5945L8.99429 12.1334C9.12172 11.9761 9.34898 11.9549 9.50189 12.0859C9.6548 12.217 9.67546 12.4507 9.54804 12.6079L7.93828 14.5945L9.54804 16.581C9.67546 16.7383 9.6548 16.972 9.50189 17.103C9.34898 17.2341 9.12172 17.2128 8.99429 17.0556L7 14.5945Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-4-inside-3)" />
            <path id="Line 71 (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M13.771 11.1638C13.9576 11.2542 14.0356 11.4769 13.9451 11.6611L10.9973 17.6664C10.9069 17.8506 10.6823 17.9267 10.4957 17.8363C10.3091 17.7458 10.2311 17.5232 10.3215 17.3389L13.2693 11.3336C13.3598 11.1494 13.5844 11.0733 13.771 11.1638Z" fill="currentColor" />
            <mask id="path-6-inside-4" fill="white">
                <path fillRule="evenodd" clipRule="evenodd" d="M17 14.5945L15.0057 17.0556C14.8783 17.2128 14.651 17.2341 14.4981 17.1031C14.3452 16.972 14.3245 16.7383 14.452 16.581L16.0617 14.5945L14.452 12.6079C14.3245 12.4507 14.3452 12.217 14.4981 12.0859C14.651 11.9549 14.8783 11.9761 15.0057 12.1334L17 14.5945Z" />
            </mask>
            <path fillRule="evenodd" clipRule="evenodd" d="M17 14.5945L15.0057 17.0556C14.8783 17.2128 14.651 17.2341 14.4981 17.1031C14.3452 16.972 14.3245 16.7383 14.452 16.581L16.0617 14.5945L14.452 12.6079C14.3245 12.4507 14.3452 12.217 14.4981 12.0859C14.651 11.9549 14.8783 11.9761 15.0057 12.1334L17 14.5945Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-6-inside-4)" />
        </svg>
    );

    const ConfigurationsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 54 54" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.420-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.420,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.420,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.420l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.420-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c-0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
    );

    const AuditLogsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 2V8H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 13H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 17H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 9H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const MoreActionsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="12" cy="5" r="1"></circle>
            <circle cx="12" cy="19" r="1"></circle>
        </svg>
    );

    // Search Icons
    const SearchIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
        </svg>
    );

    const ClearIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    );

    const ExcludedDomainsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
            <line x1="7" y1="7" x2="17" y2="17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );

    // Custom Dropdown Toggle
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <span
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', padding: '4px' }}
            title="More actions"
        >
            <MoreActionsIcon />
        </span>
    ));

    const LiveDot = ({ active }) => (
        <span
            style={{
                display: "inline-block",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                marginRight: "8px",
                backgroundColor: active ? "#28a745" : "#ffa500",
                flexShrink: 0,
            }}
        />
    );


    return (
        <div style={{
            fontFamily: '"Inter", sans-serif',
            background: '#f8f9fd',
            margin: 0,
            padding: '20px',
            minHeight: '100vh',
            overflow: 'hidden',
            width: '100%',
            boxSizing: 'border-box'
        }}>
            <div style={{
                width: '100%',
                boxSizing: 'border-box',
                maxWidth: '100%'
            }}>
                <div style={{
                    background: '#fff',
                    borderRadius: '16px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    padding: '20px',
                    width: '100%',
                    boxSizing: 'border-box',
                    minHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {/* Header Section */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px',
                        flexWrap: 'wrap',
                        gap: '15px',
                        width: '100%'
                    }}>
                        <h2 style={{
                            fontSize: '20px',
                            margin: 0,
                            fontWeight: 600,
                            flexShrink: 0
                        }}>
                            {userRole === "ADMIN" ? `All Clients (${siteCount})` : `All Sites (${siteCount})`}
                        </h2>

                        <div style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            minWidth: '250px',
                            maxWidth: '400px'
                        }}>
                            <div style={{ position: 'relative', width: '100%', maxWidth: '350px' }}>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchInputValue}
                                    onChange={(e) => {
                                        setSearchInputValue(e.target.value);
                                        if (e.target.value.trim() === "") {
                                            setShowClearButton(false);
                                            handleClearSearch();
                                        }
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearch();
                                        }
                                    }}
                                    style={{
                                        width: '100%',
                                        padding: '8px 68px 8px 12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        boxSizing: 'border-box'
                                    }}
                                />
                                <div style={{
                                    position: 'absolute',
                                    right: '4px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    display: 'flex',
                                    gap: '4px',
                                    alignItems: 'center'
                                }}>
                                    {showClearButton && (
                                        <button
                                            onClick={handleClearSearch}
                                            style={{
                                                background: 'white',
                                                border: '1px solid #ddd',
                                                borderRadius: '8px',
                                                width: '28px',
                                                height: '28px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0',
                                                cursor: 'pointer',
                                                color: '#5a6acf',
                                                transition: 'all 0.2s ease-in-out',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#5a6acf';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'white';
                                                e.currentTarget.style.color = '#5a6acf';
                                            }}
                                        >
                                            <ClearIcon />
                                        </button>
                                    )}
                                    <button
                                        onClick={handleSearch}
                                        style={{
                                            background: '#5a6acf',
                                            borderRadius: '8px',
                                            width: '28px',
                                            height: '28px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0',
                                            cursor: 'pointer',
                                            color: '#5a6acf',
                                            transition: 'all 0.2s ease-in-out',
                                            border: '1px solid #ddd',
                                            backgroundColor: 'white',
                                            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.15)',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#5a6acf';
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'white';
                                            e.currentTarget.style.color = '#5a6acf';
                                        }}
                                    >
                                        <SearchIcon />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            flexShrink: 0
                        }}>
                            <Form.Select
                                size="sm"
                                value={activeStatusFilter}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setActiveStatusFilter(val);

                                    // reset pagination + refetch
                                    setCurrentPage(1);
                                    setCurrentRangeStart(1);
                                    offset.current = 0;
                                    fetchDataWithPagination(0, searchInputValue, val);
                                }}
                                style={{
                                    width: '150px',
                                    padding: '8px 12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    boxShadow: "0.2px 2px 2px rgba(90, 106, 207, 0.2)",
                                }}
                            >
                                <option value="all">All</option>
                                <option value="live">Live</option>
                                <option value="development">Development</option>
                            </Form.Select>

                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    <Tooltip id="export-clients-tooltip">
                                        Choose All, Live, or Development and export to Excel
                                    </Tooltip>
                                }
                            >
                                <button
                                    type="button"
                                    onClick={handleOpenExportModal}
                                    disabled={isExporting || isLoading}
                                    style={{
                                        background: "white",
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        padding: "8px 14px",
                                        fontSize: "14px",
                                        color: (isExporting || isLoading) ? "#9aa3c7" : "#5a6acf",
                                        cursor: (isExporting || isLoading) ? "not-allowed" : "pointer",
                                        boxShadow: "0.2px 2px 2px rgba(90, 106, 207, 0.2)",
                                        whiteSpace: "nowrap",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                    }}
                                >
                                    Export to Excel
                                </button>
                            </OverlayTrigger>

                            {userRole === "ADMIN" && (
                                <button
                                    style={{
                                        background: "white",
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        padding: "8px 14px",
                                        fontSize: "14px",
                                        color: "#5a6acf",
                                        cursor: "pointer",
                                        boxShadow: "0.2px 2px 2px rgba(90, 106, 207, 0.2)",
                                        whiteSpace: 'nowrap'
                                    }}
                                    onClick={handleShowAddSite}
                                >
                                    + Add {siteLabelC}
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Loading State */}
                    {isLoading && (
                        <SectionLoader label="Loading clients..." />
                    )}

                    {/* Content Area */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden' }}>
                        {!isLoading && (
                            <>
                                {/* Table Section */}
                                <div style={{
                                    flex: 1,
                                    width: '100%',
                                    overflowX: 'auto',
                                    overflowY: 'visible'
                                }}>
                                    <div style={{ minWidth: '800px', width: '100%' }}>
                                        <table style={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                            tableLayout: 'fixed',
                                            minWidth: '100%'
                                        }}>
                                            <thead>
                                                <tr style={{ textAlign: 'left', fontWeight: 600, fontSize: '14px', color: '#555' }}>
                                                    <th style={{
                                                        padding: '14px 10px',
                                                        borderBottom: '1px solid #f0f0f0',
                                                        width: '25%',
                                                        boxSizing: 'border-box'
                                                    }}>Client Name</th>
                                                    <th style={{
                                                        padding: '14px 10px',
                                                        borderBottom: '1px solid #f0f0f0',
                                                        textAlign: 'center',
                                                        width: '20%',
                                                        boxSizing: 'border-box'
                                                    }}>Page/Document Count</th>
                                                    <th style={{
                                                        padding: '14px 10px',
                                                        borderBottom: '1px solid #f0f0f0',
                                                        textAlign: 'center',
                                                        width: '25%',
                                                        boxSizing: 'border-box'
                                                    }}>
                                                        Status
                                                    </th>
                                                    <th style={{
                                                        padding: '14px 10px',
                                                        borderBottom: '1px solid #f0f0f0',
                                                        textAlign: 'center',
                                                        width: '30%',
                                                        boxSizing: 'border-box'
                                                    }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(userRole === "ADMIN" || userRole === "SITEADMIN" || userRole === "TRAINER") &&
                                                    filteredSiteData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td
                                                                style={{
                                                                    padding: '14px 10px',
                                                                    borderBottom: '1px solid #f0f0f0',
                                                                    width: '25%',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    boxSizing: 'border-box'
                                                                }}
                                                            >
                                                                <Link
                                                                    to="/site/docs"
                                                                    state={{
                                                                        siteId: item.id,
                                                                        siteName: item.name,
                                                                        siteKey: item.key,
                                                                        enableFileTrain: item.enable_file_train
                                                                    }}
                                                                    style={{
                                                                        textDecoration: 'none',
                                                                        color: 'inherit',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }}
                                                                >
                                                                    {/* Tooltip ONLY on dot */}
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip>
                                                                                {item.active_status ? "Live" : "Development"}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span style={{ display: "inline-flex", alignItems: "center" }}>
                                                                            <LiveDot active={!!item.active_status} />
                                                                        </span>
                                                                    </OverlayTrigger>

                                                                    <span
                                                                        style={{
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                            flex: 1
                                                                        }}
                                                                    >
                                                                        {item.name}
                                                                    </span>
                                                                </Link>
                                                            </td>

                                                            <td style={{
                                                                padding: '14px 10px',
                                                                borderBottom: '1px solid #f0f0f0',
                                                                textAlign: 'center',
                                                                width: '20%',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                boxSizing: 'border-box'
                                                            }}>
                                                                <Link
                                                                    to="/site/docs"
                                                                    state={{ siteId: item.id, siteName: item.name, siteKey: item.key, enableFileTrain: item.enable_file_train }}
                                                                    style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                                                                >
                                                                    {item.doc_count ? item.doc_count : 0}
                                                                </Link>
                                                            </td>
                                                            <td style={{
                                                                padding: '14px 10px',
                                                                borderBottom: '1px solid #f0f0f0',
                                                                textAlign: 'center',
                                                                width: '25%',
                                                                boxSizing: 'border-box'
                                                            }}>
                                                                <Link
                                                                    to="/site/docs"
                                                                    state={{ siteId: item.id, siteName: item.name, siteKey: item.key, enableFileTrain: item.enable_file_train }}
                                                                    style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                                                                >
                                                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '4px', alignItems: 'center', flexWrap: 'wrap' }}>
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Trained Documents</Tooltip>}>
                                                                            <span style={getStatusStyle('trained')}>
                                                                                {item.trained_count || 0}
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Pending Documents</Tooltip>}>
                                                                            <span style={getStatusStyle('pending')}>
                                                                                {item.pending_count || 0}
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Failed Documents</Tooltip>}>
                                                                            <span style={getStatusStyle('failed')}>
                                                                                {item.failed_count || 0}
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </Link>
                                                            </td>
                                                            <td style={{
                                                                padding: '14px 10px',
                                                                borderBottom: '1px solid #f0f0f0',
                                                                textAlign: 'center',
                                                                width: '30%',
                                                                boxSizing: 'border-box',
                                                                cursor: 'pointer'
                                                            }}
                                                                onClick={() => {
                                                                    history("/site/docs", {
                                                                        state: {
                                                                            siteId: item.id,
                                                                            siteName: item.name,
                                                                            siteKey: item.key,
                                                                            enableFileTrain: item.enable_file_train
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', alignItems: 'center', color: '#555', flexWrap: 'wrap' }}>
                                                                    {/* Always visible actions */}
                                                                    {(userRole === "ADMIN" || userRole === "SITEADMIN") && (
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>} trigger={['hover', 'focus', 'click']}>
                                                                            <span
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleShowEditSite(
                                                                                        item.id,
                                                                                        item.name,
                                                                                        item.key,
                                                                                        item.bot_name,
                                                                                        item.banner_url,
                                                                                        item.rate_limit,
                                                                                        item.enable_file_train,
                                                                                        item.domain_url,
                                                                                        item.qdrant_db_url,
                                                                                        item.enable_full_site_training,
                                                                                        item.auto_training_interval,
                                                                                        item.enable_delete,
                                                                                        item.save_deleted_logs
                                                                                    );
                                                                                }}
                                                                                style={{ cursor: 'pointer', display: 'inline-flex' }}
                                                                            >
                                                                                <EditIcon />
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    )}

                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Trained Documents</Tooltip>}>
                                                                        <Link
                                                                            to="/site/docs"
                                                                            state={{ siteId: item.id, siteName: item.name, siteKey: item.key, enableFileTrain: item.enable_file_train }}
                                                                            style={{ color: 'inherit', textDecoration: 'none', display: 'inline-flex' }}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            <DocumentsIcon />
                                                                        </Link>
                                                                    </OverlayTrigger>

                                                                    {(userRole === "ADMIN") && (
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>{!item.enable_delete ? "Delete" : "Delete protection enabled"}</Tooltip>} trigger={['hover', 'focus', 'click']}>
                                                                            <span
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    if (!item.enable_delete) {
                                                                                        handleShowDeleteSite(item.id, item.name, item.key);
                                                                                    }
                                                                                }}
                                                                                style={{
                                                                                    cursor: !item.enable_delete ? 'pointer' : 'not-allowed',
                                                                                    opacity: !item.enable_delete ? 1 : 0.5,
                                                                                    display: 'inline-flex'
                                                                                }}
                                                                            >
                                                                                <DeleteIcon />
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    )}

                                                                    {/* Dropdown for additional actions */}
                                                                    {(userRole === "ADMIN" || userRole === "SITEADMIN") && (
                                                                        <Dropdown onClick={(e) => e.stopPropagation()}>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>More actions</Tooltip>}>
                                                                                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" />
                                                                            </OverlayTrigger>

                                                                            <Dropdown.Menu style={{ minWidth: '220px' }}>
                                                                                {/* Allow external sites */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/external_websites"
                                                                                    state={{ siteId: item.id, siteName: item.name, siteKey: item.key, enableExternalSites: item.enable_external_sites }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '5px', marginLeft: '-3px' }}
                                                                                >
                                                                                    <ExternalSitesIcon />
                                                                                    Allowed External Sites
                                                                                </Dropdown.Item>

                                                                                {/* Audit Logs */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/audit_logs"
                                                                                    state={{
                                                                                        siteId: item.id,
                                                                                        siteName: item.name,
                                                                                        siteKey: item.key,
                                                                                        enableFileTrain: item.enable_file_train
                                                                                    }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <AuditLogsIcon />
                                                                                    Audit Logs
                                                                                </Dropdown.Item>

                                                                                {/* Chat history */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/chat_history"
                                                                                    state={{ siteId: item.id, siteName: item.name }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <ChatHistoryIcon />
                                                                                    Chat History
                                                                                </Dropdown.Item>

                                                                                {/* Configurations */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/configurations"
                                                                                    state={{ siteId: item.id, siteName: item.name, userRole: userRole }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <ConfigurationsIcon />
                                                                                    Configurations
                                                                                </Dropdown.Item>

                                                                                {/* Customize Chat */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/customize_chat"
                                                                                    state={{ siteId: item.id, siteName: item.name }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <CustomizeChatIcon />
                                                                                    Customize Chat
                                                                                </Dropdown.Item>

                                                                                {/* Excluded Domains */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/excluded_domains"
                                                                                    state={{ siteId: item.id, siteName: item.name }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <ExcludedDomainsIcon />
                                                                                    Excluded Domains
                                                                                </Dropdown.Item>

                                                                                {/* Full Site Training - Only for ADMIN */}
                                                                                {(userRole === "ADMIN") && (
                                                                                    <Dropdown.Item
                                                                                        onClick={() => { handleShowFSTConfirm(item.id, item.name, item.key, item.enable_full_site_training); }}
                                                                                        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                    >
                                                                                        <FullSiteTrainingIcon />
                                                                                        Full Site Training
                                                                                    </Dropdown.Item>
                                                                                )}

                                                                                {/* Generate Chatbot Script */}
                                                                                <Dropdown.Item
                                                                                    onClick={() => {
                                                                                        if (item.chatbot_icon_name) {
                                                                                            setSelectedIcon(item.chatbot_icon_name);
                                                                                        } else {
                                                                                            setSelectedIcon("");
                                                                                        }
                                                                                        if (item.chatbot_message_icon_name) {
                                                                                            setSelectedMessageIcon(item.chatbot_message_icon_name);
                                                                                        } else {
                                                                                            setSelectedMessageIcon("");
                                                                                        }
                                                                                        setBotScriptName(item.bot_name);
                                                                                        setBotScriptKey(item.key);
                                                                                        handleShowSiteScript(item.bot_name, item.key);
                                                                                    }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <GenerateScriptIcon />
                                                                                    Generate Script
                                                                                </Dropdown.Item>

                                                                                {/* Manage Category */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/categories"
                                                                                    state={{ siteId: item.id, siteName: item.name, siteKey: item.key }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <ManageCategoryIcon />
                                                                                    Manage Category
                                                                                </Dropdown.Item>

                                                                                {/* Manage User */}
                                                                                <Dropdown.Item
                                                                                    as={Link}
                                                                                    to="/site/users"
                                                                                    state={{ siteId: item.id, siteName: item.name }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <ManageUserIcon />
                                                                                    Manage User
                                                                                </Dropdown.Item>

                                                                                {/* Test chatbot */}
                                                                                <Dropdown.Item
                                                                                    onClick={() => {
                                                                                        const url = `${process.env.REACT_APP_CHATBOT_URL}/?websiteRef=${item.key}&layout=2`;
                                                                                        window.open(url, '_blank');
                                                                                    }}
                                                                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                                                >
                                                                                    <TestChatbotIcon />
                                                                                    Test Chatbot
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Empty state */}
                                    {filteredSiteData.length === 0 && (
                                        <div style={{
                                            textAlign: 'center',
                                            padding: '40px',
                                            color: '#888',
                                            height: '400px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '100%'
                                        }}>
                                            {searchInputValue ? 'No sites found matching your search.' : 'No sites available yet.'}
                                        </div>
                                    )}
                                </div>

                                {/* Pagination Section - Always at the bottom */}
                                {filteredSiteData.length > 0 && (
                                    <div style={{
                                        marginTop: 'auto', // This pushes it to the bottom
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        paddingTop: '15px',
                                        fontSize: '14px',
                                        color: '#888',
                                        borderTop: '1px solid #f0f0f0',
                                        flexWrap: 'wrap',
                                        gap: '10px',
                                        width: '100%'
                                    }}>
                                        <div style={{ textAlign: 'left' }}>
                                            <span>Showing data {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, siteCount)} of {siteCount} entries</span>
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
                                            <button
                                                onClick={handlePrevRange}
                                                disabled={currentRangeStart === 1}
                                                style={{
                                                    padding: '4px 8px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '6px',
                                                    background: '#fff',
                                                    cursor: currentRangeStart === 1 ? 'not-allowed' : 'pointer',
                                                    fontSize: '13px',
                                                    opacity: currentRangeStart === 1 ? 0.5 : 1
                                                }}
                                            >
                                                &lt;
                                            </button>

                                            {visiblePageNumbers.map((number) => (
                                                <button
                                                    key={number}
                                                    onClick={() => paginate(number)}
                                                    style={{
                                                        padding: '4px 12px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '6px',
                                                        background: currentPage === number ? '#5A6ACF' : '#fff',
                                                        color: currentPage === number ? '#fff' : 'inherit',
                                                        cursor: 'pointer',
                                                        fontSize: '13px'
                                                    }}
                                                >
                                                    {number}
                                                </button>
                                            ))}

                                            {currentRangeStart + pagesToShow <= totalPages && (
                                                <span>...</span>
                                            )}

                                            <button
                                                onClick={handleNextRange}
                                                disabled={currentRangeStart + pagesToShow > totalPages}
                                                style={{
                                                    padding: '4px 8px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '6px',
                                                    background: '#fff',
                                                    cursor: currentRangeStart + pagesToShow > totalPages ? 'not-allowed' : 'pointer',
                                                    fontSize: '13px',
                                                    opacity: currentRangeStart + pagesToShow > totalPages ? 0.5 : 1
                                                }}
                                            >
                                                &gt;
                                            </button>
                                        </div>

                                        <div style={{ textAlign: 'right' }}>
                                            <label htmlFor="itemsPerPage" style={{ marginRight: '10px' }}>Items per page:</label>
                                            <select
                                                id="itemsPerPage"
                                                value={itemsPerPage}
                                                onChange={handleItemsPerPageChange}
                                                style={{
                                                    padding: '6px 12px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    height: '32px',
                                                    width: '80px',
                                                    fontSize: '13px',
                                                    appearance: 'menulist'
                                                }}
                                            >
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                                <option value={150}>150</option>
                                                <option value={200}>200</option>
                                                <option value={500}>500</option>
                                                <option value={1000}>1000</option>
                                            </select>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                {/* Export Clients Modal */}
                <Modal
                    show={showExportModal}
                    onHide={handleCloseExportModal}
                    centered
                    backdrop="static"
                >
                    <Modal.Header closeButton={!isExporting}>
                        <Modal.Title>Export {siteLabelC}s to Excel</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Which {siteLabel}s do you want to export?</Form.Label>
                                <div className="d-flex flex-column gap-2 mt-2">
                                    <Form.Check
                                        type="radio"
                                        id="export-status-all"
                                        name="exportStatusFilter"
                                        label="All"
                                        value="all"
                                        checked={exportStatusFilter === "all"}
                                        onChange={(e) => setExportStatusFilter(e.target.value)}
                                        disabled={isExporting}
                                    />
                                    <Form.Check
                                        type="radio"
                                        id="export-status-live"
                                        name="exportStatusFilter"
                                        label="Live"
                                        value="live"
                                        checked={exportStatusFilter === "live"}
                                        onChange={(e) => setExportStatusFilter(e.target.value)}
                                        disabled={isExporting}
                                    />
                                    <Form.Check
                                        type="radio"
                                        id="export-status-development"
                                        name="exportStatusFilter"
                                        label="Development"
                                        value="development"
                                        checked={exportStatusFilter === "development"}
                                        onChange={(e) => setExportStatusFilter(e.target.value)}
                                        disabled={isExporting}
                                    />
                                </div>
                            </Form.Group>
                            {searchInputValue && searchInputValue.trim() !== "" && (
                                <Form.Text className="text-muted">
                                    Current search &quot;{searchInputValue.trim()}&quot; will also be applied to the export.
                                </Form.Text>
                            )}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={handleCloseExportModal}
                            disabled={isExporting}
                            style={{ border: "1px solid #ddd", minWidth: "100px" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleExportClients}
                            disabled={isExporting}
                            style={{
                                backgroundColor: "#5a6acf",
                                borderColor: "#5a6acf",
                                minWidth: "120px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                            }}
                        >
                            {isExporting ? (
                                <>
                                    <Spinner animation="border" size="sm" />
                                    Exporting...
                                </>
                            ) : (
                                "Export"
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Add Site Modal */}
                <Modal
                    size="xl"
                    style={{
                        maxWidth: '1280px',
                        width: '90%',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        margin: 0
                    }}
                    show={showAddSite}
                    onHide={handleCloseAddSite}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add {siteLabelC}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col span={12}>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Name *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Name"
                                        onChange={e => handleSite(e.target.value)}
                                        maxLength={50}
                                        onBlur={validateSiteName} />
                                    <span style={{ color: "red" }}>
                                        {siteNameError}
                                    </span>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Bot Name *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Bot Name"
                                        onChange={e => handleBotName(e.target.value)}
                                        maxLength={50}
                                        onBlur={validateBotName} />
                                    <span style={{ color: "red" }}>
                                        {botNameError}
                                    </span>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Domain URL</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="https://www.example.com"
                                defaultValue=''
                                onChange={e => handleDomainUrl(e.target.value)}
                                maxLength={500}
                                onBlur={validateDomainUrl} />
                            <span style={{ color: "red" }}>
                                {domainUrlError}
                            </span>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicQdrantDbUrl">
                            <Form.Label>Qdrant DB URL</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="http://<ip address>:<port>"
                                value={qdrantDbUrl}
                                onChange={e => setQdrantDbUrl(e.target.value)}
                                maxLength={500}
                                onBlur={validateQdrantDbUrl}
                            />
                            <span style={{ color: "red" }}>
                                {qdrantDbUrlError}
                            </span>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Banner URL</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Banner URL"
                                defaultValue={defaultBanenrURL}
                                onChange={e => handleBannerUrl(e.target.value)}
                                maxLength={500}
                                onBlur={validateBannerUrl} />
                            <span style={{ color: "red" }}>
                                {bannerUrlError}
                            </span>
                        </Form.Group>

                        <Row>
                            <Col span={12}>
                                {userRole === "ADMIN" &&
                                    <div>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>Enable Full Site Training</Form.Label>
                                            <Form.Select
                                                className=" form-select-sm mb-3"
                                                aria-label=".form-select-sm example"
                                                defaultValue={enableFullSiteTraining}
                                                onChange={e => handleEnableFullSiteTraining(e.target.value)}>
                                                <option value="false">Disable</option>
                                                <option value="true">Enable</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                }
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Enable File Training</Form.Label>
                                    <Form.Select
                                        className=" form-select-sm mb-3"
                                        aria-label=".form-select-sm example"
                                        defaultValue={enableFileTrain}
                                        onChange={e => handleEnableFileTrain(e.target.value)}>
                                        <option value="false">Disable</option>
                                        <option value="true">Enable</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col span={12}>
                                {userRole === "ADMIN" &&
                                    <div>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>Auto Training Interval (In Days)</Form.Label>
                                            <Form.Control
                                                disabled={!enableFullSiteTraining}
                                                type="number"
                                                placeholder="Auto Training Interval (In Days)"
                                                defaultValue="0"
                                                min="0"
                                                onChange={e => handleAutoTrainingInterval(e.target.value)}
                                                onBlur={validateAutoTrainingInterval} />
                                            <span style={{ color: "red" }}>
                                                {autoTrainingIntervalError}
                                            </span>
                                        </Form.Group>
                                    </div>
                                }
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Rate Limit</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Rate Limit"
                                        defaultValue="0"
                                        onChange={e => handleRateLimit(e.target.value)}
                                        onBlur={validateRateLimit}
                                        min="0" />
                                    <span style={{ color: "red" }}>
                                        {rateLimitError}
                                    </span>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                <Form.Group controlId="formEnableDelete" style={{ margin: 0 }}>
                                    <Form.Check
                                        type="checkbox"
                                        label="Delete protection"
                                        checked={enableDelete}
                                        onChange={(e) => setEnableDelete(e.target.checked)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formSaveDeletedLogs" style={{ margin: 0 }}>
                                    <Form.Check
                                        type="checkbox"
                                        label="Save deletion logs"
                                        checked={saveDeletedLogs}
                                        onChange={(e) => setSaveDeletedLogs(e.target.checked)}
                                    />
                                </Form.Group>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Button variant="secondary" onClick={handleCloseAddSite} style={{ minWidth: '100px' }}>
                                    Cancel
                                </Button>{' '}
                                <Button
                                    disabled={!areAllFieldsFilled}
                                    style={{
                                        backgroundColor: '#5a6acf',
                                        borderColor: '#5a6acf',
                                        color: 'white',
                                        minWidth: '100px'
                                    }}
                                    onClick={() => {
                                        addSite();
                                    }}
                                >
                                    Add
                                </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* Edit Site Modal */}
                <Modal
                    size="xl"
                    style={{
                        maxWidth: '1280px',
                        width: '90%',
                        margin: 'auto',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                    show={showEditSite}
                    onHide={handleCloseEditSite}
                    onShow={() => {
                        setCurrentSiteInfo({
                            siteName: siteName,
                            botName: botName,
                            domainUrl: domainUrl,
                            qdrantDbUrl: qdrantDbUrl,
                            bannerUrl: bannerUrl,
                            enableFullSiteTraining: enableFullSiteTraining,
                            enableFileTrain: enableFileTrain,
                            autoTrainingInterval: autoTrainingInterval,
                            rateLimit: rateLimit,
                            enableDelete: enableDelete,
                            saveDeletedLogs: saveDeletedLogs
                        });
                    }}
                >
                    <Modal.Header closeButton>
                        {userRole === "ADMIN" ?
                            <Modal.Title>Edit Client</Modal.Title>
                            :
                            <Modal.Title>Edit Site</Modal.Title>
                        }
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col span={12}>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Name"
                                        defaultValue={siteName}
                                        onChange={e => handleSite(e.target.value)}
                                        maxLength={50}
                                        onBlur={validateSiteName} />
                                    <span style={{ color: "red" }}>
                                        {siteNameError}
                                    </span>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Bot Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Bot Name"
                                        defaultValue={botName}
                                        onChange={e => handleBotName(e.target.value)}
                                        maxLength={50}
                                        onBlur={validateBotName} />
                                    <span style={{ color: "red" }}>
                                        {botNameError}
                                    </span>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Domain URL</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Domain URL"
                                defaultValue={domainUrl}
                                onChange={e => handleDomainUrl(e.target.value)}
                                maxLength={500}
                                onBlur={validateDomainUrl} />
                            <span style={{ color: "red" }}>
                                {domainUrlError}
                            </span>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Banner URL</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Banner URL"
                                defaultValue={bannerUrl}
                                onChange={e => handleBannerUrl(e.target.value)}
                                maxLength={500}
                                onBlur={validateBannerUrl} />
                            <span style={{ color: "red" }}>
                                {bannerUrlError}
                            </span>
                        </Form.Group>
                        <Row>
                            <Col span={12}>
                                {userRole === "ADMIN" &&
                                    <div>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>Enable Full Site Training</Form.Label>
                                            <Form.Select
                                                className=" form-select-sm mb-3"
                                                aria-label=".form-select-sm example"
                                                defaultValue={enableFullSiteTraining}
                                                onChange={e => handleEnableFullSiteTraining(e.target.value)}>
                                                <option value="false">Disable</option>
                                                <option value="true">Enable</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                }
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Enable File Training</Form.Label>
                                    <Form.Select
                                        className=" form-select-sm mb-3"
                                        aria-label=".form-select-sm example"
                                        defaultValue={enableFileTrain}
                                        onChange={e => handleEnableFileTrain(e.target.value)}>
                                        <option value="false">Disable</option>
                                        <option value="true">Enable</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col span={12}>
                                {userRole === "ADMIN" &&
                                    <div>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>Auto Training Interval (In Days)</Form.Label>
                                            <Form.Control
                                                disabled={!enableFullSiteTraining}
                                                type="number"
                                                placeholder="Auto Training Interval (In Days)"
                                                defaultValue={autoTrainingInterval}
                                                min="0"
                                                onChange={e => handleAutoTrainingInterval(e.target.value)}
                                                onBlur={validateAutoTrainingInterval} />
                                            <span style={{ color: "red" }}>
                                                {autoTrainingIntervalError}
                                            </span>
                                        </Form.Group>
                                    </div>
                                }
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Rate Limit</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Rate Limit"
                                        defaultValue={rateLimit}
                                        onChange={e => handleRateLimit(e.target.value)}
                                        onBlur={validateRateLimit}
                                        min="0" />
                                    <span style={{ color: "red" }}>
                                        {rateLimitError}
                                    </span>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                <Form.Group controlId="formEnableDelete" style={{ margin: 0 }}>
                                    <Form.Check
                                        type="checkbox"
                                        label="Delete protection"
                                        checked={enableDelete}
                                        onChange={(e) => setEnableDelete(e.target.checked)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formSaveDeletedLogs" style={{ margin: 0 }}>
                                    <Form.Check
                                        type="checkbox"
                                        label="Save deletion logs"
                                        checked={saveDeletedLogs}
                                        onChange={(e) => setSaveDeletedLogs(e.target.checked)}
                                    />
                                </Form.Group>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Button variant="secondary" onClick={handleCloseEditSite} style={{ minWidth: '100px' }}>
                                    Cancel
                                </Button>{' '}
                                <Button
                                    disabled={!areAllFieldsFilled}
                                    style={{
                                        backgroundColor: '#5a6acf',
                                        borderColor: '#5a6acf',
                                        color: 'white',
                                        minWidth: '100px'
                                    }}
                                    onClick={() => {
                                        editSite();
                                    }}
                                >
                                    Update
                                </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* Delete Site Modal */}
                <DeleteConfirmation
                    show={showDeleteSite}
                    onHide={handleCloseDeleteSite}
                    onConfirm={deleteSite}
                    message={deleteMessage}
                    title="Delete"
                />

                {/* Full Site Training Modal */}
                <FullSiteTrainingConfirmation
                    show={showFSTConfirm}
                    onHide={handleCloseFSTConfirm}
                    onConfirm={trainFullSite}
                    message={confirmFTSMessage}
                    title="Full Site Training"
                    proceedFST={proceedFST}
                />

                {/* Site Script Modal */}
                <Modal show={showSiteScript} onHide={handleCloseSiteScript} size="lg" style={{ maxWidth: '90%', margin: 'auto' }} scrollable >
                    <Modal.Header closeButton>
                        <Modal.Title>{userRole === "ADMIN" ? "Client Scripts" : "Site Scripts"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(key) => setActiveTab(key)}
                            id="script-tabs"
                            className="mb-3"
                        >
                            <Tab
                                eventKey="chatbot"
                                title={
                                    <span
                                        style={{
                                            color: activeTab === "chatbot" ? "white" : "black",
                                            backgroundColor: activeTab === "chatbot" ? "#3a57e8" : "#e0e0e0",
                                            padding: "6px 12px",
                                            borderRadius: "6px",
                                            display: "inline-block"
                                        }}
                                    >
                                        Chatbot
                                    </span>
                                }
                            >
                                <Form.Group className="mb-3">
                                    <Form.Label>Select Chatbot Icon</Form.Label>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <Dropdown className="flex-grow-1" style={{ minWidth: '200px' }}>
                                            <Dropdown.Toggle
                                                variant="light"
                                                className="w-100 d-flex justify-content-between align-items-center"
                                            >
                                                {!selectedIcon || selectedIcon === "Default" ? "Default" : selectedIcon}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu
                                                className="w-100"
                                                style={{ maxHeight: "200px", overflowY: "auto" }}
                                            >
                                                <Dropdown.Item
                                                    onClick={() => handleIconSelect("Default", "CHATBOT_LOGO")}
                                                    style={{ display: "flex", alignItems: "center" }}
                                                >
                                                    Default
                                                </Dropdown.Item>
                                                <Dropdown.Divider />
                                                {availableIcons.map((icon, index) => (
                                                    <React.Fragment key={icon.name}>
                                                        <Dropdown.Item
                                                            onClick={() => handleIconSelect(icon.name, "CHATBOT_LOGO")}
                                                            style={{ display: "flex", alignItems: "center" }}
                                                        >
                                                            <img
                                                                src={icon.image}
                                                                alt={icon.name}
                                                                style={{ width: "20px", height: "20px", marginRight: "8px" }}
                                                            />
                                                            {icon.name}
                                                        </Dropdown.Item>
                                                        {index < availableIcons.length - 1 && <Dropdown.Divider />}
                                                    </React.Fragment>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="upload-tooltip">Upload custom chatbot icon</Tooltip>}
                                        >
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => fileInputRef.current?.click()}
                                                disabled={isChatbotIconUploading}
                                                style={{ padding: '6px', backgroundColor: '#5a6acf', borderColor: '#5a6acf', color: 'white' }}
                                                className="btn "
                                            >
                                                {isChatbotIconUploading ? (
                                                    <Spinner animation="border" size="sm" />
                                                ) : (
                                                    <svg
                                                        width="25"
                                                        height="16"
                                                        viewBox="0 0 16 16"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="1.3"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                    </svg>
                                                )}
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept="image/png, image/jpeg, image/jpg"
                                        style={{ display: "none" }}
                                        onChange={(e) => handleFileUpload(e, "CHATBOT_LOGO")}
                                    />
                                </Form.Group>

                                {selectedIcon && selectedIcon !== "Default" && (
                                    <div className="mb-3">
                                        <span>Selected Chatbot Icon Preview: </span>
                                        <img
                                            src={availableIcons.find(icon => icon.name === selectedIcon)?.image}
                                            alt="Selected Icon"
                                            style={{ width: '40px', height: '40px', marginLeft: '10px' }}
                                        />
                                    </div>

                                )}

                                <hr style={{
                                    margin: '15px 0',
                                    border: '0',
                                    borderTop: '1px solid #e0e0e0',
                                    opacity: 0.7
                                }} />

                                <Form.Group className="mb-3">
                                    <Form.Label>Select Chatbot Message Icon</Form.Label>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <Dropdown className="flex-grow-1" style={{ minWidth: '200px' }}>
                                            <Dropdown.Toggle
                                                variant="light"
                                                className="w-100 d-flex justify-content-between align-items-center"
                                            >
                                                {!selectedMessageIcon || selectedMessageIcon === "Default" ? "Default" : selectedMessageIcon}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu
                                                className="w-100"
                                                style={{ maxHeight: "200px", overflowY: "auto" }}
                                            >
                                                <Dropdown.Item
                                                    onClick={() => handleIconSelect("Default", "CHATBOT_MESSAGE_ICON")}
                                                    style={{ display: "flex", alignItems: "center" }}
                                                >
                                                    Default
                                                </Dropdown.Item>
                                                <Dropdown.Divider />
                                                {availableChatbotMessageIcons.map((icon, index) => (
                                                    <React.Fragment key={icon.name}>
                                                        <Dropdown.Item
                                                            onClick={() => handleIconSelect(icon.name, "CHATBOT_MESSAGE_ICON")}
                                                            style={{ display: "flex", alignItems: "center" }}
                                                        >
                                                            <img
                                                                src={icon.image}
                                                                alt={icon.name}
                                                                style={{ width: "20px", height: "20px", marginRight: "8px" }}
                                                            />
                                                            {icon.name}
                                                        </Dropdown.Item>
                                                        {index < availableChatbotMessageIcons.length - 1 && <Dropdown.Divider />}
                                                    </React.Fragment>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="upload-message-tooltip">Upload custom message icon</Tooltip>}
                                        >
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => {
                                                    // Create a new file input for message icon
                                                    const input = document.createElement('input');
                                                    input.type = 'file';
                                                    input.accept = 'image/png, image/jpeg, image/jpg';
                                                    input.onchange = (e) => handleFileUpload(e, "CHATBOT_MESSAGE_ICON");
                                                    input.click();
                                                }}
                                                disabled={isChatbotMessageIconUploading}
                                                style={{ padding: '6px', backgroundColor: '#5a6acf', borderColor: '#5a6acf', color: 'white' }}
                                                className="btn "
                                            >
                                                {isChatbotMessageIconUploading ? (
                                                    <Spinner animation="border" size="sm" />
                                                ) : (
                                                    <svg
                                                        width="25"
                                                        height="16"
                                                        viewBox="0 0 16 16"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="1.3"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                    </svg>
                                                )}
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                </Form.Group>

                                {selectedMessageIcon && selectedMessageIcon !== "Default" && (
                                    <div className="mb-3">
                                        <span>Selected Chatbot Message Icon Preview: </span>
                                        <img
                                            src={availableChatbotMessageIcons.find(icon => icon.name === selectedMessageIcon)?.image}
                                            alt="Selected Message Icon"
                                            style={{ width: '40px', height: '40px', marginLeft: '10px' }}
                                        />
                                    </div>
                                )}

                                <hr style={{
                                    margin: '15px 0',
                                    border: '0',
                                    borderTop: '1px solid #e0e0e0',
                                    opacity: 0.7
                                }} />

                                <h5>Chatbot HTML Code:</h5>
                                <div
                                    className="container p-3 my-3 border"
                                    style={{ maxHeight: "300px", overflowY: "auto", width: '100%', boxSizing: 'border-box' }}
                                >
                                    <button
                                        className="btn "
                                        style={{ float: "right", backgroundColor: '#5a6acf', borderColor: '#5a6acf', color: 'white' }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(chatbotHtml);
                                            info("Script copied to clipboard.", true);
                                        }}
                                    >
                                        Copy
                                    </button>
                                    <HtmlContentDisplay htmlContent={chatbotHtml} />
                                </div>

                                <h5>Chatbot Javascript Code:</h5>
                                <div
                                    className="container p-3 my-3 border"
                                    style={{ maxHeight: "400px", overflowY: "auto", width: '100%', boxSizing: 'border-box' }}
                                >
                                    <button
                                        className="btn"
                                        style={{ float: "right", backgroundColor: '#5a6acf', borderColor: '#5a6acf', color: 'white' }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(chatbotJs);
                                            info("Script copied to clipboard.", true);
                                        }}
                                    >
                                        Copy
                                    </button>
                                    <HtmlContentDisplay htmlContent={chatbotJs} />
                                </div>
                            </Tab>

                            <Tab
                                eventKey="aiSearch"
                                title={
                                    <span
                                        style={{
                                            color: activeTab === "aiSearch" ? "white" : "black",
                                            backgroundColor: activeTab === "aiSearch" ? "#3a57e8" : "#e0e0e0",
                                            padding: "6px 12px",
                                            borderRadius: "6px",
                                            display: "inline-block"
                                        }}
                                    >
                                        AI Search
                                    </span>
                                }
                            >
                                <h5>Source Finder HTML Code:</h5>
                                <div
                                    className="container p-3 my-3 border"
                                    style={{ maxHeight: "300px", overflowY: "auto", width: '100%', boxSizing: 'border-box' }}
                                >
                                    <button
                                        className="btn "
                                        style={{ float: "right", backgroundColor: '#5a6acf', borderColor: '#5a6acf', color: 'white' }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(sourceFinderHtml);
                                            info("Script copied to clipboard.", true);
                                        }}
                                    >
                                        Copy
                                    </button>
                                    <HtmlContentDisplay htmlContent={sourceFinderHtml} />
                                </div>

                                <h5>Source Finder Javascript Code:</h5>
                                <div
                                    className="container p-3 my-3 border"
                                    style={{ maxHeight: "400px", overflowY: "auto", width: '100%', boxSizing: 'border-box' }}
                                >
                                    <button
                                        className="btn"
                                        style={{ float: "right", backgroundColor: '#5a6acf', borderColor: '#5a6acf', color: 'white' }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(sourceFinderJs);
                                            info("Script copied to clipboard.", true);
                                        }}
                                    >
                                        Copy
                                    </button>
                                    <HtmlContentDisplay htmlContent={sourceFinderJs} />
                                </div>
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                </Modal>
            </div>
            <FullSiteTrainingConfirmation
                showModal={showFSTConfirm}
                confirmModal={trainFullSite}
                hideModal={handleCloseFSTConfirm}
                id={siteId}
                key={"fst-" + key}
                message={confirmFTSMessage}
                proceedFST={proceedFST}
            />
            <DeleteConfirmation
                showModal={showDeleteSite}
                proceedDelete="true"
                confirmModal={deleteSite}
                hideModal={handleCloseDeleteSite}
                id={siteId}
                key={"del-" + key}
                message={deleteMessage}
            />
        </div>
    );
});

export default Site;